var cov_238fl4zerh = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Cascader/Cascader.tsx",
      hash = "8eb8c8b140351aa3712a77e334041b7132b00185",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Cascader/Cascader.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 19
        },
        end: {
          line: 33,
          column: 1
        }
      },
      "1": {
        start: {
          line: 32,
          column: 9
        },
        end: {
          line: 32,
          column: 55
        }
      },
      "2": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "3": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 36,
          column: 52
        }
      },
      "4": {
        start: {
          line: 36,
          column: 41
        },
        end: {
          line: 36,
          column: 52
        }
      },
      "5": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 37
        }
      },
      "6": {
        start: {
          line: 37,
          column: 25
        },
        end: {
          line: 37,
          column: 37
        }
      },
      "7": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 43
        }
      },
      "8": {
        start: {
          line: 41,
          column: 21
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "9": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 91,
          column: 16
        }
      },
      "10": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 97,
          column: 5
        }
      },
      "11": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 109,
          column: 6
        }
      },
      "12": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 27
        }
      },
      "13": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 43
        }
      },
      "14": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 56
        }
      },
      "15": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 56
        }
      },
      "16": {
        start: {
          line: 116,
          column: 4
        },
        end: {
          line: 116,
          column: 50
        }
      },
      "17": {
        start: {
          line: 117,
          column: 4
        },
        end: {
          line: 117,
          column: 54
        }
      },
      "18": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 118,
          column: 58
        }
      },
      "19": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 119,
          column: 60
        }
      },
      "20": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 120,
          column: 50
        }
      },
      "21": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 121,
          column: 50
        }
      },
      "22": {
        start: {
          line: 122,
          column: 4
        },
        end: {
          line: 122,
          column: 42
        }
      },
      "23": {
        start: {
          line: 123,
          column: 4
        },
        end: {
          line: 123,
          column: 52
        }
      },
      "24": {
        start: {
          line: 124,
          column: 4
        },
        end: {
          line: 124,
          column: 46
        }
      },
      "25": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 52
        }
      },
      "26": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 32
        }
      },
      "27": {
        start: {
          line: 127,
          column: 25
        },
        end: {
          line: 129,
          column: 5
        }
      },
      "28": {
        start: {
          line: 130,
          column: 4
        },
        end: {
          line: 136,
          column: 5
        }
      },
      "29": {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 135,
          column: 7
        }
      },
      "30": {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 43
        }
      },
      "31": {
        start: {
          line: 134,
          column: 8
        },
        end: {
          line: 134,
          column: 52
        }
      },
      "32": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 29
        }
      },
      "33": {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 141,
          column: 23
        }
      },
      "34": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 142,
          column: 28
        }
      },
      "35": {
        start: {
          line: 143,
          column: 4
        },
        end: {
          line: 147,
          column: 5
        }
      },
      "36": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 146,
          column: 7
        }
      },
      "37": {
        start: {
          line: 151,
          column: 4
        },
        end: {
          line: 151,
          column: 37
        }
      },
      "38": {
        start: {
          line: 152,
          column: 4
        },
        end: {
          line: 152,
          column: 50
        }
      },
      "39": {
        start: {
          line: 153,
          column: 4
        },
        end: {
          line: 153,
          column: 23
        }
      },
      "40": {
        start: {
          line: 154,
          column: 37
        },
        end: {
          line: 154,
          column: 47
        }
      },
      "41": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 103
        }
      },
      "42": {
        start: {
          line: 155,
          column: 56
        },
        end: {
          line: 155,
          column: 103
        }
      },
      "43": {
        start: {
          line: 156,
          column: 4
        },
        end: {
          line: 159,
          column: 5
        }
      },
      "44": {
        start: {
          line: 157,
          column: 6
        },
        end: {
          line: 157,
          column: 73
        }
      },
      "45": {
        start: {
          line: 158,
          column: 6
        },
        end: {
          line: 158,
          column: 30
        }
      },
      "46": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 173,
          column: 5
        }
      },
      "47": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 169,
          column: 7
        }
      },
      "48": {
        start: {
          line: 166,
          column: 8
        },
        end: {
          line: 168,
          column: 15
        }
      },
      "49": {
        start: {
          line: 167,
          column: 10
        },
        end: {
          line: 167,
          column: 22
        }
      },
      "50": {
        start: {
          line: 170,
          column: 6
        },
        end: {
          line: 172,
          column: 7
        }
      },
      "51": {
        start: {
          line: 171,
          column: 8
        },
        end: {
          line: 171,
          column: 36
        }
      },
      "52": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 176,
          column: 5
        }
      },
      "53": {
        start: {
          line: 175,
          column: 6
        },
        end: {
          line: 175,
          column: 23
        }
      },
      "54": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 32
        }
      },
      "55": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 181,
          column: 25
        }
      },
      "56": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 187,
          column: 5
        }
      },
      "57": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 30
        }
      },
      "58": {
        start: {
          line: 188,
          column: 4
        },
        end: {
          line: 188,
          column: 27
        }
      },
      "59": {
        start: {
          line: 192,
          column: 37
        },
        end: {
          line: 192,
          column: 47
        }
      },
      "60": {
        start: {
          line: 193,
          column: 4
        },
        end: {
          line: 193,
          column: 52
        }
      },
      "61": {
        start: {
          line: 197,
          column: 18
        },
        end: {
          line: 197,
          column: 53
        }
      },
      "62": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 203,
          column: 7
        }
      },
      "63": {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 203,
          column: 7
        }
      },
      "64": {
        start: {
          line: 200,
          column: 8
        },
        end: {
          line: 200,
          column: 28
        }
      },
      "65": {
        start: {
          line: 201,
          column: 13
        },
        end: {
          line: 203,
          column: 7
        }
      },
      "66": {
        start: {
          line: 202,
          column: 8
        },
        end: {
          line: 202,
          column: 29
        }
      },
      "67": {
        start: {
          line: 204,
          column: 4
        },
        end: {
          line: 204,
          column: 26
        }
      },
      "68": {
        start: {
          line: 208,
          column: 4
        },
        end: {
          line: 208,
          column: 17
        }
      },
      "69": {
        start: {
          line: 212,
          column: 4
        },
        end: {
          line: 212,
          column: 64
        }
      },
      "70": {
        start: {
          line: 216,
          column: 4
        },
        end: {
          line: 216,
          column: 22
        }
      },
      "71": {
        start: {
          line: 220,
          column: 4
        },
        end: {
          line: 220,
          column: 67
        }
      },
      "72": {
        start: {
          line: 224,
          column: 4
        },
        end: {
          line: 224,
          column: 65
        }
      },
      "73": {
        start: {
          line: 224,
          column: 54
        },
        end: {
          line: 224,
          column: 65
        }
      },
      "74": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 225,
          column: 65
        }
      },
      "75": {
        start: {
          line: 225,
          column: 54
        },
        end: {
          line: 225,
          column: 65
        }
      },
      "76": {
        start: {
          line: 226,
          column: 4
        },
        end: {
          line: 226,
          column: 16
        }
      },
      "77": {
        start: {
          line: 230,
          column: 51
        },
        end: {
          line: 230,
          column: 61
        }
      },
      "78": {
        start: {
          line: 231,
          column: 4
        },
        end: {
          line: 234,
          column: 5
        }
      },
      "79": {
        start: {
          line: 232,
          column: 6
        },
        end: {
          line: 232,
          column: 33
        }
      },
      "80": {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 233,
          column: 12
        }
      },
      "81": {
        start: {
          line: 235,
          column: 16
        },
        end: {
          line: 235,
          column: 46
        }
      },
      "82": {
        start: {
          line: 236,
          column: 20
        },
        end: {
          line: 236,
          column: 43
        }
      },
      "83": {
        start: {
          line: 237,
          column: 4
        },
        end: {
          line: 237,
          column: 24
        }
      },
      "84": {
        start: {
          line: 237,
          column: 18
        },
        end: {
          line: 237,
          column: 24
        }
      },
      "85": {
        start: {
          line: 238,
          column: 4
        },
        end: {
          line: 242,
          column: 5
        }
      },
      "86": {
        start: {
          line: 240,
          column: 8
        },
        end: {
          line: 240,
          column: 43
        }
      },
      "87": {
        start: {
          line: 246,
          column: 28
        },
        end: {
          line: 246,
          column: 38
        }
      },
      "88": {
        start: {
          line: 247,
          column: 4
        },
        end: {
          line: 247,
          column: 34
        }
      },
      "89": {
        start: {
          line: 247,
          column: 28
        },
        end: {
          line: 247,
          column: 34
        }
      },
      "90": {
        start: {
          line: 248,
          column: 4
        },
        end: {
          line: 248,
          column: 50
        }
      },
      "91": {
        start: {
          line: 248,
          column: 44
        },
        end: {
          line: 248,
          column: 50
        }
      },
      "92": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 262,
          column: 5
        }
      },
      "93": {
        start: {
          line: 250,
          column: 6
        },
        end: {
          line: 250,
          column: 33
        }
      },
      "94": {
        start: {
          line: 252,
          column: 16
        },
        end: {
          line: 252,
          column: 39
        }
      },
      "95": {
        start: {
          line: 253,
          column: 19
        },
        end: {
          line: 253,
          column: 44
        }
      },
      "96": {
        start: {
          line: 254,
          column: 6
        },
        end: {
          line: 254,
          column: 61
        }
      },
      "97": {
        start: {
          line: 254,
          column: 55
        },
        end: {
          line: 254,
          column: 61
        }
      },
      "98": {
        start: {
          line: 255,
          column: 6
        },
        end: {
          line: 261,
          column: 7
        }
      },
      "99": {
        start: {
          line: 256,
          column: 23
        },
        end: {
          line: 256,
          column: 50
        }
      },
      "100": {
        start: {
          line: 257,
          column: 8
        },
        end: {
          line: 257,
          column: 25
        }
      },
      "101": {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 258,
          column: 44
        }
      },
      "102": {
        start: {
          line: 260,
          column: 8
        },
        end: {
          line: 260,
          column: 24
        }
      },
      "103": {
        start: {
          line: 266,
          column: 17
        },
        end: {
          line: 266,
          column: 69
        }
      },
      "104": {
        start: {
          line: 267,
          column: 4
        },
        end: {
          line: 270,
          column: 5
        }
      },
      "105": {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 268,
          column: 52
        }
      },
      "106": {
        start: {
          line: 268,
          column: 33
        },
        end: {
          line: 268,
          column: 52
        }
      },
      "107": {
        start: {
          line: 269,
          column: 6
        },
        end: {
          line: 269,
          column: 29
        }
      },
      "108": {
        start: {
          line: 274,
          column: 50
        },
        end: {
          line: 274,
          column: 60
        }
      },
      "109": {
        start: {
          line: 275,
          column: 4
        },
        end: {
          line: 281,
          column: 5
        }
      },
      "110": {
        start: {
          line: 276,
          column: 17
        },
        end: {
          line: 276,
          column: 98
        }
      },
      "111": {
        start: {
          line: 277,
          column: 6
        },
        end: {
          line: 279,
          column: 7
        }
      },
      "112": {
        start: {
          line: 278,
          column: 8
        },
        end: {
          line: 278,
          column: 20
        }
      },
      "113": {
        start: {
          line: 280,
          column: 6
        },
        end: {
          line: 280,
          column: 55
        }
      },
      "114": {
        start: {
          line: 280,
          column: 32
        },
        end: {
          line: 280,
          column: 55
        }
      },
      "115": {
        start: {
          line: 282,
          column: 4
        },
        end: {
          line: 285,
          column: 5
        }
      },
      "116": {
        start: {
          line: 283,
          column: 6
        },
        end: {
          line: 283,
          column: 40
        }
      },
      "117": {
        start: {
          line: 284,
          column: 6
        },
        end: {
          line: 284,
          column: 33
        }
      },
      "118": {
        start: {
          line: 286,
          column: 4
        },
        end: {
          line: 288,
          column: 10
        }
      },
      "119": {
        start: {
          line: 287,
          column: 6
        },
        end: {
          line: 287,
          column: 44
        }
      },
      "120": {
        start: {
          line: 292,
          column: 4
        },
        end: {
          line: 292,
          column: 61
        }
      },
      "121": {
        start: {
          line: 292,
          column: 55
        },
        end: {
          line: 292,
          column: 61
        }
      },
      "122": {
        start: {
          line: 293,
          column: 4
        },
        end: {
          line: 293,
          column: 25
        }
      },
      "123": {
        start: {
          line: 297,
          column: 21
        },
        end: {
          line: 297,
          column: 31
        }
      },
      "124": {
        start: {
          line: 298,
          column: 4
        },
        end: {
          line: 298,
          column: 31
        }
      },
      "125": {
        start: {
          line: 299,
          column: 4
        },
        end: {
          line: 299,
          column: 51
        }
      },
      "126": {
        start: {
          line: 299,
          column: 28
        },
        end: {
          line: 299,
          column: 51
        }
      },
      "127": {
        start: {
          line: 300,
          column: 4
        },
        end: {
          line: 300,
          column: 32
        }
      },
      "128": {
        start: {
          line: 303,
          column: 4
        },
        end: {
          line: 303,
          column: 49
        }
      },
      "129": {
        start: {
          line: 303,
          column: 21
        },
        end: {
          line: 303,
          column: 44
        }
      },
      "130": {
        start: {
          line: 307,
          column: 25
        },
        end: {
          line: 307,
          column: 35
        }
      },
      "131": {
        start: {
          line: 308,
          column: 4
        },
        end: {
          line: 308,
          column: 46
        }
      },
      "132": {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 309,
          column: 64
        }
      },
      "133": {
        start: {
          line: 309,
          column: 18
        },
        end: {
          line: 309,
          column: 64
        }
      },
      "134": {
        start: {
          line: 313,
          column: 4
        },
        end: {
          line: 313,
          column: 44
        }
      },
      "135": {
        start: {
          line: 313,
          column: 38
        },
        end: {
          line: 313,
          column: 44
        }
      },
      "136": {
        start: {
          line: 314,
          column: 4
        },
        end: {
          line: 314,
          column: 36
        }
      },
      "137": {
        start: {
          line: 314,
          column: 30
        },
        end: {
          line: 314,
          column: 36
        }
      },
      "138": {
        start: {
          line: 317,
          column: 4
        },
        end: {
          line: 317,
          column: 98
        }
      },
      "139": {
        start: {
          line: 317,
          column: 92
        },
        end: {
          line: 317,
          column: 98
        }
      },
      "140": {
        start: {
          line: 320,
          column: 4
        },
        end: {
          line: 320,
          column: 96
        }
      },
      "141": {
        start: {
          line: 320,
          column: 90
        },
        end: {
          line: 320,
          column: 96
        }
      },
      "142": {
        start: {
          line: 322,
          column: 57
        },
        end: {
          line: 322,
          column: 67
        }
      },
      "143": {
        start: {
          line: 323,
          column: 23
        },
        end: {
          line: 323,
          column: 33
        }
      },
      "144": {
        start: {
          line: 324,
          column: 4
        },
        end: {
          line: 328,
          column: 5
        }
      },
      "145": {
        start: {
          line: 325,
          column: 27
        },
        end: {
          line: 325,
          column: 41
        }
      },
      "146": {
        start: {
          line: 326,
          column: 21
        },
        end: {
          line: 326,
          column: 73
        }
      },
      "147": {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 327,
          column: 53
        }
      },
      "148": {
        start: {
          line: 327,
          column: 33
        },
        end: {
          line: 327,
          column: 53
        }
      },
      "149": {
        start: {
          line: 330,
          column: 4
        },
        end: {
          line: 330,
          column: 37
        }
      },
      "150": {
        start: {
          line: 330,
          column: 20
        },
        end: {
          line: 330,
          column: 37
        }
      },
      "151": {
        start: {
          line: 331,
          column: 4
        },
        end: {
          line: 331,
          column: 63
        }
      },
      "152": {
        start: {
          line: 333,
          column: 4
        },
        end: {
          line: 335,
          column: 5
        }
      },
      "153": {
        start: {
          line: 334,
          column: 6
        },
        end: {
          line: 334,
          column: 32
        }
      },
      "154": {
        start: {
          line: 339,
          column: 4
        },
        end: {
          line: 342,
          column: 5
        }
      },
      "155": {
        start: {
          line: 340,
          column: 6
        },
        end: {
          line: 340,
          column: 24
        }
      },
      "156": {
        start: {
          line: 341,
          column: 6
        },
        end: {
          line: 341,
          column: 35
        }
      },
      "157": {
        start: {
          line: 345,
          column: 4
        },
        end: {
          line: 351,
          column: 5
        }
      },
      "158": {
        start: {
          line: 346,
          column: 6
        },
        end: {
          line: 346,
          column: 25
        }
      },
      "159": {
        start: {
          line: 348,
          column: 6
        },
        end: {
          line: 350,
          column: 7
        }
      },
      "160": {
        start: {
          line: 349,
          column: 8
        },
        end: {
          line: 349,
          column: 31
        }
      },
      "161": {
        start: {
          line: 355,
          column: 71
        },
        end: {
          line: 355,
          column: 81
        }
      },
      "162": {
        start: {
          line: 356,
          column: 4
        },
        end: {
          line: 359,
          column: 5
        }
      },
      "163": {
        start: {
          line: 357,
          column: 6
        },
        end: {
          line: 357,
          column: 24
        }
      },
      "164": {
        start: {
          line: 358,
          column: 6
        },
        end: {
          line: 358,
          column: 24
        }
      },
      "165": {
        start: {
          line: 360,
          column: 20
        },
        end: {
          line: 360,
          column: 24
        }
      },
      "166": {
        start: {
          line: 361,
          column: 4
        },
        end: {
          line: 361,
          column: 26
        }
      },
      "167": {
        start: {
          line: 362,
          column: 4
        },
        end: {
          line: 364,
          column: 5
        }
      },
      "168": {
        start: {
          line: 363,
          column: 6
        },
        end: {
          line: 363,
          column: 23
        }
      },
      "169": {
        start: {
          line: 366,
          column: 4
        },
        end: {
          line: 370,
          column: 5
        }
      },
      "170": {
        start: {
          line: 367,
          column: 6
        },
        end: {
          line: 369,
          column: 7
        }
      },
      "171": {
        start: {
          line: 368,
          column: 8
        },
        end: {
          line: 368,
          column: 20
        }
      },
      "172": {
        start: {
          line: 374,
          column: 91
        },
        end: {
          line: 374,
          column: 101
        }
      },
      "173": {
        start: {
          line: 375,
          column: 21
        },
        end: {
          line: 375,
          column: 31
        }
      },
      "174": {
        start: {
          line: 377,
          column: 18
        },
        end: {
          line: 388,
          column: 5
        }
      },
      "175": {
        start: {
          line: 390,
          column: 24
        },
        end: {
          line: 390,
          column: 28
        }
      },
      "176": {
        start: {
          line: 392,
          column: 34
        },
        end: {
          line: 402,
          column: 5
        }
      },
      "177": {
        start: {
          line: 404,
          column: 19
        },
        end: {
          line: 427,
          column: 6
        }
      },
      "178": {
        start: {
          line: 405,
          column: 6
        },
        end: {
          line: 411,
          column: 10
        }
      },
      "179": {
        start: {
          line: 409,
          column: 22
        },
        end: {
          line: 409,
          column: 55
        }
      },
      "180": {
        start: {
          line: 410,
          column: 10
        },
        end: {
          line: 410,
          column: 26
        }
      },
      "181": {
        start: {
          line: 412,
          column: 6
        },
        end: {
          line: 425,
          column: 7
        }
      },
      "182": {
        start: {
          line: 413,
          column: 8
        },
        end: {
          line: 413,
          column: 40
        }
      },
      "183": {
        start: {
          line: 414,
          column: 8
        },
        end: {
          line: 424,
          column: 9
        }
      },
      "184": {
        start: {
          line: 426,
          column: 6
        },
        end: {
          line: 426,
          column: 17
        }
      },
      "185": {
        start: {
          line: 429,
          column: 4
        },
        end: {
          line: 431,
          column: 5
        }
      },
      "186": {
        start: {
          line: 430,
          column: 6
        },
        end: {
          line: 430,
          column: 32
        }
      },
      "187": {
        start: {
          line: 433,
          column: 22
        },
        end: {
          line: 433,
          column: 96
        }
      },
      "188": {
        start: {
          line: 435,
          column: 4
        },
        end: {
          line: 439,
          column: 5
        }
      },
      "189": {
        start: {
          line: 443,
          column: 60
        },
        end: {
          line: 443,
          column: 70
        }
      },
      "190": {
        start: {
          line: 444,
          column: 25
        },
        end: {
          line: 444,
          column: 35
        }
      },
      "191": {
        start: {
          line: 445,
          column: 22
        },
        end: {
          line: 445,
          column: 26
        }
      },
      "192": {
        start: {
          line: 446,
          column: 22
        },
        end: {
          line: 446,
          column: 82
        }
      },
      "193": {
        start: {
          line: 447,
          column: 22
        },
        end: {
          line: 447,
          column: 117
        }
      },
      "194": {
        start: {
          line: 448,
          column: 4
        },
        end: {
          line: 448,
          column: 47
        }
      },
      "195": {
        start: {
          line: 448,
          column: 36
        },
        end: {
          line: 448,
          column: 47
        }
      },
      "196": {
        start: {
          line: 449,
          column: 4
        },
        end: {
          line: 452,
          column: 5
        }
      },
      "197": {
        start: {
          line: 450,
          column: 6
        },
        end: {
          line: 450,
          column: 38
        }
      },
      "198": {
        start: {
          line: 451,
          column: 6
        },
        end: {
          line: 451,
          column: 17
        }
      },
      "199": {
        start: {
          line: 453,
          column: 4
        },
        end: {
          line: 453,
          column: 26
        }
      },
      "200": {
        start: {
          line: 454,
          column: 17
        },
        end: {
          line: 454,
          column: 34
        }
      },
      "201": {
        start: {
          line: 455,
          column: 4
        },
        end: {
          line: 469,
          column: 5
        }
      },
      "202": {
        start: {
          line: 487,
          column: 8
        },
        end: {
          line: 487,
          column: 18
        }
      },
      "203": {
        start: {
          line: 488,
          column: 25
        },
        end: {
          line: 488,
          column: 35
        }
      },
      "204": {
        start: {
          line: 489,
          column: 22
        },
        end: {
          line: 489,
          column: 26
        }
      },
      "205": {
        start: {
          line: 490,
          column: 22
        },
        end: {
          line: 490,
          column: 117
        }
      },
      "206": {
        start: {
          line: 492,
          column: 4
        },
        end: {
          line: 518,
          column: 5
        }
      },
      "207": {
        start: {
          line: 522,
          column: 48
        },
        end: {
          line: 522,
          column: 58
        }
      },
      "208": {
        start: {
          line: 523,
          column: 4
        },
        end: {
          line: 523,
          column: 47
        }
      },
      "209": {
        start: {
          line: 523,
          column: 17
        },
        end: {
          line: 523,
          column: 47
        }
      },
      "210": {
        start: {
          line: 524,
          column: 4
        },
        end: {
          line: 525,
          column: 38
        }
      },
      "211": {
        start: {
          line: 525,
          column: 6
        },
        end: {
          line: 525,
          column: 38
        }
      },
      "212": {
        start: {
          line: 526,
          column: 4
        },
        end: {
          line: 526,
          column: 34
        }
      },
      "213": {
        start: {
          line: 530,
          column: 54
        },
        end: {
          line: 530,
          column: 64
        }
      },
      "214": {
        start: {
          line: 531,
          column: 22
        },
        end: {
          line: 531,
          column: 26
        }
      },
      "215": {
        start: {
          line: 532,
          column: 22
        },
        end: {
          line: 542,
          column: 5
        }
      },
      "216": {
        start: {
          line: 544,
          column: 4
        },
        end: {
          line: 578,
          column: 5
        }
      },
      "217": {
        start: {
          line: 554,
          column: 10
        },
        end: {
          line: 554,
          column: 28
        }
      },
      "218": {
        start: {
          line: 555,
          column: 10
        },
        end: {
          line: 558,
          column: 11
        }
      },
      "219": {
        start: {
          line: 556,
          column: 12
        },
        end: {
          line: 556,
          column: 45
        }
      },
      "220": {
        start: {
          line: 557,
          column: 12
        },
        end: {
          line: 557,
          column: 30
        }
      },
      "221": {
        start: {
          line: 582,
          column: 0
        },
        end: {
          line: 589,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 23,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 55
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 22
          }
        },
        loc: {
          start: {
            line: 35,
            column: 63
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 35
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 90,
            column: 2
          },
          end: {
            line: 90,
            column: 3
          }
        },
        loc: {
          start: {
            line: 90,
            column: 59
          },
          end: {
            line: 137,
            column: 3
          }
        },
        line: 90
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 139,
            column: 2
          },
          end: {
            line: 139,
            column: 3
          }
        },
        loc: {
          start: {
            line: 139,
            column: 22
          },
          end: {
            line: 148,
            column: 3
          }
        },
        line: 139
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 150,
            column: 2
          },
          end: {
            line: 150,
            column: 3
          }
        },
        loc: {
          start: {
            line: 150,
            column: 95
          },
          end: {
            line: 177,
            column: 3
          }
        },
        line: 150
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 166,
            column: 19
          },
          end: {
            line: 166,
            column: 20
          }
        },
        loc: {
          start: {
            line: 166,
            column: 25
          },
          end: {
            line: 168,
            column: 9
          }
        },
        line: 166
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 179,
            column: 3
          }
        },
        loc: {
          start: {
            line: 179,
            column: 25
          },
          end: {
            line: 182,
            column: 3
          }
        },
        line: 179
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 184,
            column: 2
          },
          end: {
            line: 184,
            column: 3
          }
        },
        loc: {
          start: {
            line: 184,
            column: 14
          },
          end: {
            line: 189,
            column: 3
          }
        },
        line: 184
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 191,
            column: 2
          },
          end: {
            line: 191,
            column: 3
          }
        },
        loc: {
          start: {
            line: 191,
            column: 20
          },
          end: {
            line: 194,
            column: 3
          }
        },
        line: 191
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 196,
            column: 2
          },
          end: {
            line: 196,
            column: 3
          }
        },
        loc: {
          start: {
            line: 196,
            column: 17
          },
          end: {
            line: 205,
            column: 3
          }
        },
        line: 196
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 207,
            column: 2
          },
          end: {
            line: 207,
            column: 3
          }
        },
        loc: {
          start: {
            line: 207,
            column: 30
          },
          end: {
            line: 209,
            column: 3
          }
        },
        line: 207
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 211,
            column: 2
          },
          end: {
            line: 211,
            column: 3
          }
        },
        loc: {
          start: {
            line: 211,
            column: 18
          },
          end: {
            line: 213,
            column: 3
          }
        },
        line: 211
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 215,
            column: 2
          },
          end: {
            line: 215,
            column: 3
          }
        },
        loc: {
          start: {
            line: 215,
            column: 26
          },
          end: {
            line: 217,
            column: 3
          }
        },
        line: 215
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 219,
            column: 2
          },
          end: {
            line: 219,
            column: 3
          }
        },
        loc: {
          start: {
            line: 219,
            column: 19
          },
          end: {
            line: 221,
            column: 3
          }
        },
        line: 219
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 223,
            column: 2
          },
          end: {
            line: 223,
            column: 3
          }
        },
        loc: {
          start: {
            line: 223,
            column: 34
          },
          end: {
            line: 227,
            column: 3
          }
        },
        line: 223
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 229,
            column: 2
          },
          end: {
            line: 229,
            column: 3
          }
        },
        loc: {
          start: {
            line: 229,
            column: 15
          },
          end: {
            line: 243,
            column: 3
          }
        },
        line: 229
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 239,
            column: 12
          },
          end: {
            line: 239,
            column: 13
          }
        },
        loc: {
          start: {
            line: 239,
            column: 21
          },
          end: {
            line: 241,
            column: 7
          }
        },
        line: 239
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 245,
            column: 2
          },
          end: {
            line: 245,
            column: 3
          }
        },
        loc: {
          start: {
            line: 245,
            column: 37
          },
          end: {
            line: 263,
            column: 3
          }
        },
        line: 245
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 265,
            column: 2
          },
          end: {
            line: 265,
            column: 3
          }
        },
        loc: {
          start: {
            line: 265,
            column: 33
          },
          end: {
            line: 271,
            column: 3
          }
        },
        line: 265
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 273,
            column: 2
          },
          end: {
            line: 273,
            column: 3
          }
        },
        loc: {
          start: {
            line: 273,
            column: 111
          },
          end: {
            line: 289,
            column: 3
          }
        },
        line: 273
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 286,
            column: 38
          },
          end: {
            line: 286,
            column: 39
          }
        },
        loc: {
          start: {
            line: 286,
            column: 44
          },
          end: {
            line: 288,
            column: 5
          }
        },
        line: 286
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 291,
            column: 2
          },
          end: {
            line: 291,
            column: 3
          }
        },
        loc: {
          start: {
            line: 291,
            column: 22
          },
          end: {
            line: 294,
            column: 3
          }
        },
        line: 291
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 296,
            column: 2
          },
          end: {
            line: 296,
            column: 3
          }
        },
        loc: {
          start: {
            line: 296,
            column: 16
          },
          end: {
            line: 304,
            column: 3
          }
        },
        line: 296
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 303,
            column: 15
          },
          end: {
            line: 303,
            column: 16
          }
        },
        loc: {
          start: {
            line: 303,
            column: 21
          },
          end: {
            line: 303,
            column: 44
          }
        },
        line: 303
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 306,
            column: 2
          },
          end: {
            line: 306,
            column: 3
          }
        },
        loc: {
          start: {
            line: 306,
            column: 31
          },
          end: {
            line: 310,
            column: 3
          }
        },
        line: 306
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 312,
            column: 2
          },
          end: {
            line: 312,
            column: 3
          }
        },
        loc: {
          start: {
            line: 312,
            column: 46
          },
          end: {
            line: 336,
            column: 3
          }
        },
        line: 312
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 338,
            column: 2
          },
          end: {
            line: 338,
            column: 3
          }
        },
        loc: {
          start: {
            line: 338,
            column: 24
          },
          end: {
            line: 352,
            column: 3
          }
        },
        line: 338
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 354,
            column: 2
          },
          end: {
            line: 354,
            column: 3
          }
        },
        loc: {
          start: {
            line: 354,
            column: 44
          },
          end: {
            line: 371,
            column: 3
          }
        },
        line: 354
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 373,
            column: 2
          },
          end: {
            line: 373,
            column: 3
          }
        },
        loc: {
          start: {
            line: 373,
            column: 15
          },
          end: {
            line: 440,
            column: 3
          }
        },
        line: 373
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 404,
            column: 28
          },
          end: {
            line: 404,
            column: 29
          }
        },
        loc: {
          start: {
            line: 404,
            column: 38
          },
          end: {
            line: 427,
            column: 5
          }
        },
        line: 404
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 408,
            column: 22
          },
          end: {
            line: 408,
            column: 23
          }
        },
        loc: {
          start: {
            line: 408,
            column: 27
          },
          end: {
            line: 411,
            column: 9
          }
        },
        line: 408
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 442,
            column: 2
          },
          end: {
            line: 442,
            column: 3
          }
        },
        loc: {
          start: {
            line: 442,
            column: 23
          },
          end: {
            line: 470,
            column: 3
          }
        },
        line: 442
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 472,
            column: 2
          },
          end: {
            line: 472,
            column: 3
          }
        },
        loc: {
          start: {
            line: 472,
            column: 21
          },
          end: {
            line: 519,
            column: 3
          }
        },
        line: 472
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 521,
            column: 2
          },
          end: {
            line: 521,
            column: 3
          }
        },
        loc: {
          start: {
            line: 521,
            column: 16
          },
          end: {
            line: 527,
            column: 3
          }
        },
        line: 521
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 529,
            column: 2
          },
          end: {
            line: 529,
            column: 3
          }
        },
        loc: {
          start: {
            line: 529,
            column: 11
          },
          end: {
            line: 579,
            column: 3
          }
        },
        line: 529
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 553,
            column: 13
          },
          end: {
            line: 553,
            column: 14
          }
        },
        loc: {
          start: {
            line: 553,
            column: 19
          },
          end: {
            line: 559,
            column: 9
          }
        },
        line: 553
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 32,
            column: 9
          },
          end: {
            line: 32,
            column: 55
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 32,
            column: 17
          },
          end: {
            line: 32,
            column: 48
          }
        }, {
          start: {
            line: 32,
            column: 51
          },
          end: {
            line: 32,
            column: 55
          }
        }],
        line: 32
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 52
          }
        }, {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 52
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 37
          }
        }, {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 37
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 106,
            column: 16
          },
          end: {
            line: 106,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 55
          },
          end: {
            line: 106,
            column: 69
          }
        }, {
          start: {
            line: 106,
            column: 72
          },
          end: {
            line: 106,
            column: 81
          }
        }],
        line: 106
      },
      "4": {
        loc: {
          start: {
            line: 107,
            column: 19
          },
          end: {
            line: 107,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 107,
            column: 19
          },
          end: {
            line: 107,
            column: 36
          }
        }, {
          start: {
            line: 107,
            column: 40
          },
          end: {
            line: 107,
            column: 64
          }
        }],
        line: 107
      },
      "5": {
        loc: {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        }, {
          start: {
            line: 130,
            column: 4
          },
          end: {
            line: 136,
            column: 5
          }
        }],
        line: 130
      },
      "6": {
        loc: {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        }, {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 135,
            column: 7
          }
        }],
        line: 131
      },
      "7": {
        loc: {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        }],
        line: 143
      },
      "8": {
        loc: {
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 97
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 143,
            column: 8
          },
          end: {
            line: 143,
            column: 37
          }
        }, {
          start: {
            line: 143,
            column: 41
          },
          end: {
            line: 143,
            column: 58
          }
        }, {
          start: {
            line: 143,
            column: 62
          },
          end: {
            line: 143,
            column: 97
          }
        }],
        line: 143
      },
      "9": {
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 103
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 103
          }
        }, {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 103
          }
        }],
        line: 155
      },
      "10": {
        loc: {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }, {
          start: {
            line: 156,
            column: 4
          },
          end: {
            line: 159,
            column: 5
          }
        }],
        line: 156
      },
      "11": {
        loc: {
          start: {
            line: 157,
            column: 26
          },
          end: {
            line: 157,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 157,
            column: 26
          },
          end: {
            line: 157,
            column: 42
          }
        }, {
          start: {
            line: 157,
            column: 47
          },
          end: {
            line: 157,
            column: 71
          }
        }],
        line: 157
      },
      "12": {
        loc: {
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        }, {
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 173,
            column: 5
          }
        }],
        line: 161
      },
      "13": {
        loc: {
          start: {
            line: 162,
            column: 6
          },
          end: {
            line: 163,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 162,
            column: 7
          },
          end: {
            line: 162,
            column: 43
          }
        }, {
          start: {
            line: 162,
            column: 47
          },
          end: {
            line: 162,
            column: 64
          }
        }, {
          start: {
            line: 163,
            column: 7
          },
          end: {
            line: 163,
            column: 41
          }
        }, {
          start: {
            line: 163,
            column: 45
          },
          end: {
            line: 163,
            column: 61
          }
        }],
        line: 162
      },
      "14": {
        loc: {
          start: {
            line: 165,
            column: 6
          },
          end: {
            line: 169,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 165,
            column: 6
          },
          end: {
            line: 169,
            column: 7
          }
        }, {
          start: {
            line: 165,
            column: 6
          },
          end: {
            line: 169,
            column: 7
          }
        }],
        line: 165
      },
      "15": {
        loc: {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        }, {
          start: {
            line: 170,
            column: 6
          },
          end: {
            line: 172,
            column: 7
          }
        }],
        line: 170
      },
      "16": {
        loc: {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }, {
          start: {
            line: 174,
            column: 4
          },
          end: {
            line: 176,
            column: 5
          }
        }],
        line: 174
      },
      "17": {
        loc: {
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 174,
            column: 71
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 174,
            column: 32
          }
        }, {
          start: {
            line: 174,
            column: 36
          },
          end: {
            line: 174,
            column: 71
          }
        }],
        line: 174
      },
      "18": {
        loc: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }, {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 187,
            column: 5
          }
        }],
        line: 185
      },
      "19": {
        loc: {
          start: {
            line: 193,
            column: 11
          },
          end: {
            line: 193,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 193,
            column: 11
          },
          end: {
            line: 193,
            column: 41
          }
        }, {
          start: {
            line: 193,
            column: 45
          },
          end: {
            line: 193,
            column: 52
          }
        }],
        line: 193
      },
      "20": {
        loc: {
          start: {
            line: 197,
            column: 18
          },
          end: {
            line: 197,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 18
          },
          end: {
            line: 197,
            column: 28
          }
        }, {
          start: {
            line: 197,
            column: 32
          },
          end: {
            line: 197,
            column: 53
          }
        }],
        line: 197
      },
      "21": {
        loc: {
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 203,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 203,
            column: 7
          }
        }, {
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 203,
            column: 7
          }
        }],
        line: 198
      },
      "22": {
        loc: {
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 203,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 203,
            column: 7
          }
        }, {
          start: {
            line: 199,
            column: 6
          },
          end: {
            line: 203,
            column: 7
          }
        }],
        line: 199
      },
      "23": {
        loc: {
          start: {
            line: 201,
            column: 13
          },
          end: {
            line: 203,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 201,
            column: 13
          },
          end: {
            line: 203,
            column: 7
          }
        }, {
          start: {
            line: 201,
            column: 13
          },
          end: {
            line: 203,
            column: 7
          }
        }],
        line: 201
      },
      "24": {
        loc: {
          start: {
            line: 224,
            column: 4
          },
          end: {
            line: 224,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 224,
            column: 4
          },
          end: {
            line: 224,
            column: 65
          }
        }, {
          start: {
            line: 224,
            column: 4
          },
          end: {
            line: 224,
            column: 65
          }
        }],
        line: 224
      },
      "25": {
        loc: {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 225,
            column: 65
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 225,
            column: 65
          }
        }, {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 225,
            column: 65
          }
        }],
        line: 225
      },
      "26": {
        loc: {
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: 231,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }],
        line: 231
      },
      "27": {
        loc: {
          start: {
            line: 231,
            column: 8
          },
          end: {
            line: 231,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 231,
            column: 8
          },
          end: {
            line: 231,
            column: 19
          }
        }, {
          start: {
            line: 231,
            column: 23
          },
          end: {
            line: 231,
            column: 38
          }
        }],
        line: 231
      },
      "28": {
        loc: {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 237,
            column: 24
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 237,
            column: 24
          }
        }, {
          start: {
            line: 237,
            column: 4
          },
          end: {
            line: 237,
            column: 24
          }
        }],
        line: 237
      },
      "29": {
        loc: {
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 247,
            column: 34
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 247,
            column: 34
          }
        }, {
          start: {
            line: 247,
            column: 4
          },
          end: {
            line: 247,
            column: 34
          }
        }],
        line: 247
      },
      "30": {
        loc: {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 248,
            column: 50
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 248,
            column: 50
          }
        }, {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 248,
            column: 50
          }
        }],
        line: 248
      },
      "31": {
        loc: {
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 248,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 248,
            column: 8
          },
          end: {
            line: 248,
            column: 32
          }
        }, {
          start: {
            line: 248,
            column: 36
          },
          end: {
            line: 248,
            column: 42
          }
        }],
        line: 248
      },
      "32": {
        loc: {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        }, {
          start: {
            line: 249,
            column: 4
          },
          end: {
            line: 262,
            column: 5
          }
        }],
        line: 249
      },
      "33": {
        loc: {
          start: {
            line: 249,
            column: 8
          },
          end: {
            line: 249,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 249,
            column: 8
          },
          end: {
            line: 249,
            column: 14
          }
        }, {
          start: {
            line: 249,
            column: 18
          },
          end: {
            line: 249,
            column: 31
          }
        }],
        line: 249
      },
      "34": {
        loc: {
          start: {
            line: 254,
            column: 6
          },
          end: {
            line: 254,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 254,
            column: 6
          },
          end: {
            line: 254,
            column: 61
          }
        }, {
          start: {
            line: 254,
            column: 6
          },
          end: {
            line: 254,
            column: 61
          }
        }],
        line: 254
      },
      "35": {
        loc: {
          start: {
            line: 254,
            column: 10
          },
          end: {
            line: 254,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 10
          },
          end: {
            line: 254,
            column: 23
          }
        }, {
          start: {
            line: 254,
            column: 27
          },
          end: {
            line: 254,
            column: 53
          }
        }],
        line: 254
      },
      "36": {
        loc: {
          start: {
            line: 256,
            column: 23
          },
          end: {
            line: 256,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 256,
            column: 23
          },
          end: {
            line: 256,
            column: 44
          }
        }, {
          start: {
            line: 256,
            column: 48
          },
          end: {
            line: 256,
            column: 50
          }
        }],
        line: 256
      },
      "37": {
        loc: {
          start: {
            line: 257,
            column: 15
          },
          end: {
            line: 257,
            column: 25
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 257,
            column: 15
          },
          end: {
            line: 257,
            column: 19
          }
        }, {
          start: {
            line: 257,
            column: 23
          },
          end: {
            line: 257,
            column: 25
          }
        }],
        line: 257
      },
      "38": {
        loc: {
          start: {
            line: 267,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 267,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        }, {
          start: {
            line: 267,
            column: 4
          },
          end: {
            line: 270,
            column: 5
          }
        }],
        line: 267
      },
      "39": {
        loc: {
          start: {
            line: 268,
            column: 6
          },
          end: {
            line: 268,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 268,
            column: 6
          },
          end: {
            line: 268,
            column: 52
          }
        }, {
          start: {
            line: 268,
            column: 6
          },
          end: {
            line: 268,
            column: 52
          }
        }],
        line: 268
      },
      "40": {
        loc: {
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 281,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 281,
            column: 5
          }
        }, {
          start: {
            line: 275,
            column: 4
          },
          end: {
            line: 281,
            column: 5
          }
        }],
        line: 275
      },
      "41": {
        loc: {
          start: {
            line: 275,
            column: 8
          },
          end: {
            line: 275,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 275,
            column: 8
          },
          end: {
            line: 275,
            column: 17
          }
        }, {
          start: {
            line: 275,
            column: 21
          },
          end: {
            line: 275,
            column: 25
          }
        }, {
          start: {
            line: 275,
            column: 29
          },
          end: {
            line: 275,
            column: 40
          }
        }],
        line: 275
      },
      "42": {
        loc: {
          start: {
            line: 276,
            column: 17
          },
          end: {
            line: 276,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 276,
            column: 17
          },
          end: {
            line: 276,
            column: 35
          }
        }, {
          start: {
            line: 276,
            column: 39
          },
          end: {
            line: 276,
            column: 98
          }
        }],
        line: 276
      },
      "43": {
        loc: {
          start: {
            line: 277,
            column: 6
          },
          end: {
            line: 279,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 277,
            column: 6
          },
          end: {
            line: 279,
            column: 7
          }
        }, {
          start: {
            line: 277,
            column: 6
          },
          end: {
            line: 279,
            column: 7
          }
        }],
        line: 277
      },
      "44": {
        loc: {
          start: {
            line: 277,
            column: 10
          },
          end: {
            line: 277,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 277,
            column: 10
          },
          end: {
            line: 277,
            column: 16
          }
        }, {
          start: {
            line: 277,
            column: 20
          },
          end: {
            line: 277,
            column: 48
          }
        }, {
          start: {
            line: 277,
            column: 52
          },
          end: {
            line: 277,
            column: 83
          }
        }],
        line: 277
      },
      "45": {
        loc: {
          start: {
            line: 280,
            column: 6
          },
          end: {
            line: 280,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 280,
            column: 6
          },
          end: {
            line: 280,
            column: 55
          }
        }, {
          start: {
            line: 280,
            column: 6
          },
          end: {
            line: 280,
            column: 55
          }
        }],
        line: 280
      },
      "46": {
        loc: {
          start: {
            line: 280,
            column: 10
          },
          end: {
            line: 280,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 280,
            column: 10
          },
          end: {
            line: 280,
            column: 22
          }
        }, {
          start: {
            line: 280,
            column: 26
          },
          end: {
            line: 280,
            column: 30
          }
        }],
        line: 280
      },
      "47": {
        loc: {
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        }, {
          start: {
            line: 282,
            column: 4
          },
          end: {
            line: 285,
            column: 5
          }
        }],
        line: 282
      },
      "48": {
        loc: {
          start: {
            line: 292,
            column: 4
          },
          end: {
            line: 292,
            column: 61
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 292,
            column: 4
          },
          end: {
            line: 292,
            column: 61
          }
        }, {
          start: {
            line: 292,
            column: 4
          },
          end: {
            line: 292,
            column: 61
          }
        }],
        line: 292
      },
      "49": {
        loc: {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 51
          }
        }, {
          start: {
            line: 299,
            column: 4
          },
          end: {
            line: 299,
            column: 51
          }
        }],
        line: 299
      },
      "50": {
        loc: {
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 309,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 309,
            column: 64
          }
        }, {
          start: {
            line: 309,
            column: 4
          },
          end: {
            line: 309,
            column: 64
          }
        }],
        line: 309
      },
      "51": {
        loc: {
          start: {
            line: 313,
            column: 4
          },
          end: {
            line: 313,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 313,
            column: 4
          },
          end: {
            line: 313,
            column: 44
          }
        }, {
          start: {
            line: 313,
            column: 4
          },
          end: {
            line: 313,
            column: 44
          }
        }],
        line: 313
      },
      "52": {
        loc: {
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 314,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 314,
            column: 36
          }
        }, {
          start: {
            line: 314,
            column: 4
          },
          end: {
            line: 314,
            column: 36
          }
        }],
        line: 314
      },
      "53": {
        loc: {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 317,
            column: 98
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 317,
            column: 98
          }
        }, {
          start: {
            line: 317,
            column: 4
          },
          end: {
            line: 317,
            column: 98
          }
        }],
        line: 317
      },
      "54": {
        loc: {
          start: {
            line: 317,
            column: 8
          },
          end: {
            line: 317,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 317,
            column: 8
          },
          end: {
            line: 317,
            column: 13
          }
        }, {
          start: {
            line: 317,
            column: 17
          },
          end: {
            line: 317,
            column: 18
          }
        }, {
          start: {
            line: 317,
            column: 22
          },
          end: {
            line: 317,
            column: 90
          }
        }],
        line: 317
      },
      "55": {
        loc: {
          start: {
            line: 320,
            column: 4
          },
          end: {
            line: 320,
            column: 96
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 320,
            column: 4
          },
          end: {
            line: 320,
            column: 96
          }
        }, {
          start: {
            line: 320,
            column: 4
          },
          end: {
            line: 320,
            column: 96
          }
        }],
        line: 320
      },
      "56": {
        loc: {
          start: {
            line: 320,
            column: 8
          },
          end: {
            line: 320,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 320,
            column: 8
          },
          end: {
            line: 320,
            column: 9
          }
        }, {
          start: {
            line: 320,
            column: 13
          },
          end: {
            line: 320,
            column: 88
          }
        }],
        line: 320
      },
      "57": {
        loc: {
          start: {
            line: 322,
            column: 12
          },
          end: {
            line: 322,
            column: 40
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 322,
            column: 21
          },
          end: {
            line: 322,
            column: 40
          }
        }],
        line: 322
      },
      "58": {
        loc: {
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 328,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 328,
            column: 5
          }
        }, {
          start: {
            line: 324,
            column: 4
          },
          end: {
            line: 328,
            column: 5
          }
        }],
        line: 324
      },
      "59": {
        loc: {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 327,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 327,
            column: 53
          }
        }, {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 327,
            column: 53
          }
        }],
        line: 327
      },
      "60": {
        loc: {
          start: {
            line: 330,
            column: 4
          },
          end: {
            line: 330,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 330,
            column: 4
          },
          end: {
            line: 330,
            column: 37
          }
        }, {
          start: {
            line: 330,
            column: 4
          },
          end: {
            line: 330,
            column: 37
          }
        }],
        line: 330
      },
      "61": {
        loc: {
          start: {
            line: 331,
            column: 37
          },
          end: {
            line: 331,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 331,
            column: 37
          },
          end: {
            line: 331,
            column: 45
          }
        }, {
          start: {
            line: 331,
            column: 49
          },
          end: {
            line: 331,
            column: 60
          }
        }],
        line: 331
      },
      "62": {
        loc: {
          start: {
            line: 333,
            column: 4
          },
          end: {
            line: 335,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 333,
            column: 4
          },
          end: {
            line: 335,
            column: 5
          }
        }, {
          start: {
            line: 333,
            column: 4
          },
          end: {
            line: 335,
            column: 5
          }
        }],
        line: 333
      },
      "63": {
        loc: {
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 342,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 342,
            column: 5
          }
        }, {
          start: {
            line: 339,
            column: 4
          },
          end: {
            line: 342,
            column: 5
          }
        }],
        line: 339
      },
      "64": {
        loc: {
          start: {
            line: 345,
            column: 4
          },
          end: {
            line: 351,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 345,
            column: 4
          },
          end: {
            line: 351,
            column: 5
          }
        }, {
          start: {
            line: 345,
            column: 4
          },
          end: {
            line: 351,
            column: 5
          }
        }],
        line: 345
      },
      "65": {
        loc: {
          start: {
            line: 348,
            column: 6
          },
          end: {
            line: 350,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 348,
            column: 6
          },
          end: {
            line: 350,
            column: 7
          }
        }, {
          start: {
            line: 348,
            column: 6
          },
          end: {
            line: 350,
            column: 7
          }
        }],
        line: 348
      },
      "66": {
        loc: {
          start: {
            line: 356,
            column: 4
          },
          end: {
            line: 359,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 356,
            column: 4
          },
          end: {
            line: 359,
            column: 5
          }
        }, {
          start: {
            line: 356,
            column: 4
          },
          end: {
            line: 359,
            column: 5
          }
        }],
        line: 356
      },
      "67": {
        loc: {
          start: {
            line: 362,
            column: 4
          },
          end: {
            line: 364,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 362,
            column: 4
          },
          end: {
            line: 364,
            column: 5
          }
        }, {
          start: {
            line: 362,
            column: 4
          },
          end: {
            line: 364,
            column: 5
          }
        }],
        line: 362
      },
      "68": {
        loc: {
          start: {
            line: 366,
            column: 4
          },
          end: {
            line: 370,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 366,
            column: 4
          },
          end: {
            line: 370,
            column: 5
          }
        }, {
          start: {
            line: 366,
            column: 4
          },
          end: {
            line: 370,
            column: 5
          }
        }],
        line: 366
      },
      "69": {
        loc: {
          start: {
            line: 366,
            column: 8
          },
          end: {
            line: 366,
            column: 30
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 366,
            column: 8
          },
          end: {
            line: 366,
            column: 16
          }
        }, {
          start: {
            line: 366,
            column: 20
          },
          end: {
            line: 366,
            column: 30
          }
        }],
        line: 366
      },
      "70": {
        loc: {
          start: {
            line: 367,
            column: 6
          },
          end: {
            line: 369,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 367,
            column: 6
          },
          end: {
            line: 369,
            column: 7
          }
        }, {
          start: {
            line: 367,
            column: 6
          },
          end: {
            line: 369,
            column: 7
          }
        }],
        line: 367
      },
      "71": {
        loc: {
          start: {
            line: 367,
            column: 12
          },
          end: {
            line: 367,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 367,
            column: 12
          },
          end: {
            line: 367,
            column: 30
          }
        }, {
          start: {
            line: 367,
            column: 34
          },
          end: {
            line: 367,
            column: 51
          }
        }],
        line: 367
      },
      "72": {
        loc: {
          start: {
            line: 406,
            column: 8
          },
          end: {
            line: 411,
            column: 10
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 406,
            column: 8
          },
          end: {
            line: 406,
            column: 16
          }
        }, {
          start: {
            line: 407,
            column: 8
          },
          end: {
            line: 407,
            column: 33
          }
        }, {
          start: {
            line: 408,
            column: 8
          },
          end: {
            line: 411,
            column: 10
          }
        }],
        line: 406
      },
      "73": {
        loc: {
          start: {
            line: 412,
            column: 6
          },
          end: {
            line: 425,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 412,
            column: 6
          },
          end: {
            line: 425,
            column: 7
          }
        }, {
          start: {
            line: 412,
            column: 6
          },
          end: {
            line: 425,
            column: 7
          }
        }],
        line: 412
      },
      "74": {
        loc: {
          start: {
            line: 412,
            column: 10
          },
          end: {
            line: 412,
            column: 79
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 412,
            column: 10
          },
          end: {
            line: 412,
            column: 18
          }
        }, {
          start: {
            line: 412,
            column: 22
          },
          end: {
            line: 412,
            column: 43
          }
        }, {
          start: {
            line: 412,
            column: 47
          },
          end: {
            line: 412,
            column: 79
          }
        }],
        line: 412
      },
      "75": {
        loc: {
          start: {
            line: 429,
            column: 4
          },
          end: {
            line: 431,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 429,
            column: 4
          },
          end: {
            line: 431,
            column: 5
          }
        }, {
          start: {
            line: 429,
            column: 4
          },
          end: {
            line: 431,
            column: 5
          }
        }],
        line: 429
      },
      "76": {
        loc: {
          start: {
            line: 433,
            column: 22
          },
          end: {
            line: 433,
            column: 96
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 433,
            column: 50
          },
          end: {
            line: 433,
            column: 83
          }
        }, {
          start: {
            line: 433,
            column: 86
          },
          end: {
            line: 433,
            column: 96
          }
        }],
        line: 433
      },
      "77": {
        loc: {
          start: {
            line: 433,
            column: 22
          },
          end: {
            line: 433,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 433,
            column: 22
          },
          end: {
            line: 433,
            column: 26
          }
        }, {
          start: {
            line: 433,
            column: 30
          },
          end: {
            line: 433,
            column: 47
          }
        }],
        line: 433
      },
      "78": {
        loc: {
          start: {
            line: 447,
            column: 47
          },
          end: {
            line: 447,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 447,
            column: 47
          },
          end: {
            line: 447,
            column: 52
          }
        }, {
          start: {
            line: 447,
            column: 56
          },
          end: {
            line: 447,
            column: 63
          }
        }],
        line: 447
      },
      "79": {
        loc: {
          start: {
            line: 447,
            column: 65
          },
          end: {
            line: 447,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 447,
            column: 65
          },
          end: {
            line: 447,
            column: 72
          }
        }, {
          start: {
            line: 447,
            column: 76
          },
          end: {
            line: 447,
            column: 81
          }
        }],
        line: 447
      },
      "80": {
        loc: {
          start: {
            line: 448,
            column: 4
          },
          end: {
            line: 448,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 448,
            column: 4
          },
          end: {
            line: 448,
            column: 47
          }
        }, {
          start: {
            line: 448,
            column: 4
          },
          end: {
            line: 448,
            column: 47
          }
        }],
        line: 448
      },
      "81": {
        loc: {
          start: {
            line: 448,
            column: 8
          },
          end: {
            line: 448,
            column: 34
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 448,
            column: 8
          },
          end: {
            line: 448,
            column: 14
          }
        }, {
          start: {
            line: 448,
            column: 18
          },
          end: {
            line: 448,
            column: 34
          }
        }],
        line: 448
      },
      "82": {
        loc: {
          start: {
            line: 449,
            column: 4
          },
          end: {
            line: 452,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 449,
            column: 4
          },
          end: {
            line: 452,
            column: 5
          }
        }, {
          start: {
            line: 449,
            column: 4
          },
          end: {
            line: 452,
            column: 5
          }
        }],
        line: 449
      },
      "83": {
        loc: {
          start: {
            line: 467,
            column: 9
          },
          end: {
            line: 467,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 467,
            column: 28
          },
          end: {
            line: 467,
            column: 74
          }
        }, {
          start: {
            line: 467,
            column: 77
          },
          end: {
            line: 467,
            column: 81
          }
        }],
        line: 467
      },
      "84": {
        loc: {
          start: {
            line: 490,
            column: 47
          },
          end: {
            line: 490,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 490,
            column: 47
          },
          end: {
            line: 490,
            column: 52
          }
        }, {
          start: {
            line: 490,
            column: 56
          },
          end: {
            line: 490,
            column: 63
          }
        }],
        line: 490
      },
      "85": {
        loc: {
          start: {
            line: 490,
            column: 65
          },
          end: {
            line: 490,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 490,
            column: 65
          },
          end: {
            line: 490,
            column: 72
          }
        }, {
          start: {
            line: 490,
            column: 76
          },
          end: {
            line: 490,
            column: 81
          }
        }],
        line: 490
      },
      "86": {
        loc: {
          start: {
            line: 523,
            column: 4
          },
          end: {
            line: 523,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 523,
            column: 4
          },
          end: {
            line: 523,
            column: 47
          }
        }, {
          start: {
            line: 523,
            column: 4
          },
          end: {
            line: 523,
            column: 47
          }
        }],
        line: 523
      },
      "87": {
        loc: {
          start: {
            line: 524,
            column: 4
          },
          end: {
            line: 525,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 524,
            column: 4
          },
          end: {
            line: 525,
            column: 38
          }
        }, {
          start: {
            line: 524,
            column: 4
          },
          end: {
            line: 525,
            column: 38
          }
        }],
        line: 524
      },
      "88": {
        loc: {
          start: {
            line: 524,
            column: 8
          },
          end: {
            line: 524,
            column: 88
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 524,
            column: 8
          },
          end: {
            line: 524,
            column: 19
          }
        }, {
          start: {
            line: 524,
            column: 24
          },
          end: {
            line: 524,
            column: 34
          }
        }, {
          start: {
            line: 524,
            column: 38
          },
          end: {
            line: 524,
            column: 56
          }
        }, {
          start: {
            line: 524,
            column: 62
          },
          end: {
            line: 524,
            column: 66
          }
        }, {
          start: {
            line: 524,
            column: 70
          },
          end: {
            line: 524,
            column: 87
          }
        }],
        line: 524
      },
      "89": {
        loc: {
          start: {
            line: 536,
            column: 8
          },
          end: {
            line: 536,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 536,
            column: 8
          },
          end: {
            line: 536,
            column: 13
          }
        }, {
          start: {
            line: 536,
            column: 17
          },
          end: {
            line: 536,
            column: 24
          }
        }],
        line: 536
      },
      "90": {
        loc: {
          start: {
            line: 537,
            column: 8
          },
          end: {
            line: 537,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 537,
            column: 8
          },
          end: {
            line: 537,
            column: 32
          }
        }, {
          start: {
            line: 537,
            column: 36
          },
          end: {
            line: 537,
            column: 46
          }
        }],
        line: 537
      },
      "91": {
        loc: {
          start: {
            line: 538,
            column: 8
          },
          end: {
            line: 538,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 538,
            column: 8
          },
          end: {
            line: 538,
            column: 25
          }
        }, {
          start: {
            line: 538,
            column: 29
          },
          end: {
            line: 538,
            column: 39
          }
        }],
        line: 538
      },
      "92": {
        loc: {
          start: {
            line: 539,
            column: 8
          },
          end: {
            line: 539,
            column: 24
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 539,
            column: 8
          },
          end: {
            line: 539,
            column: 15
          }
        }, {
          start: {
            line: 539,
            column: 19
          },
          end: {
            line: 539,
            column: 24
          }
        }],
        line: 539
      },
      "93": {
        loc: {
          start: {
            line: 541,
            column: 39
          },
          end: {
            line: 541,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 541,
            column: 39
          },
          end: {
            line: 541,
            column: 44
          }
        }, {
          start: {
            line: 541,
            column: 48
          },
          end: {
            line: 541,
            column: 55
          }
        }],
        line: 541
      },
      "94": {
        loc: {
          start: {
            line: 547,
            column: 18
          },
          end: {
            line: 547,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 547,
            column: 38
          },
          end: {
            line: 547,
            column: 40
          }
        }, {
          start: {
            line: 547,
            column: 43
          },
          end: {
            line: 547,
            column: 44
          }
        }],
        line: 547
      },
      "95": {
        loc: {
          start: {
            line: 555,
            column: 10
          },
          end: {
            line: 558,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 555,
            column: 10
          },
          end: {
            line: 558,
            column: 11
          }
        }, {
          start: {
            line: 555,
            column: 10
          },
          end: {
            line: 558,
            column: 11
          }
        }],
        line: 555
      },
      "96": {
        loc: {
          start: {
            line: 555,
            column: 14
          },
          end: {
            line: 555,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 555,
            column: 14
          },
          end: {
            line: 555,
            column: 16
          }
        }, {
          start: {
            line: 555,
            column: 20
          },
          end: {
            line: 555,
            column: 45
          }
        }],
        line: 555
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0,
      "200": 0,
      "201": 0,
      "202": 0,
      "203": 0,
      "204": 0,
      "205": 0,
      "206": 0,
      "207": 0,
      "208": 0,
      "209": 0,
      "210": 0,
      "211": 0,
      "212": 0,
      "213": 0,
      "214": 0,
      "215": 0,
      "216": 0,
      "217": 0,
      "218": 0,
      "219": 0,
      "220": 0,
      "221": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0, 0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0],
      "68": [0, 0],
      "69": [0, 0],
      "70": [0, 0],
      "71": [0, 0],
      "72": [0, 0, 0],
      "73": [0, 0],
      "74": [0, 0, 0],
      "75": [0, 0],
      "76": [0, 0],
      "77": [0, 0],
      "78": [0, 0],
      "79": [0, 0],
      "80": [0, 0],
      "81": [0, 0],
      "82": [0, 0],
      "83": [0, 0],
      "84": [0, 0],
      "85": [0, 0],
      "86": [0, 0],
      "87": [0, 0],
      "88": [0, 0, 0, 0, 0],
      "89": [0, 0],
      "90": [0, 0],
      "91": [0, 0],
      "92": [0, 0],
      "93": [0, 0],
      "94": [0, 0],
      "95": [0, 0],
      "96": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Cascader/Cascader.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import immer from 'immer';
import classnames from 'classnames';
import { isFunc } from '../utils/is';
import { PureComponent } from '../component';
import { getUidStr } from '../utils/uid';
import DatumTree from '../Datum/Tree';
import { selectClass } from '../Select/styles';
import { cascaderClass } from './styles';
import Result from './Result';
import CascaderList from './List';
import FilterList from './FilterList';
import { docSize } from '../utils/dom/document';
import { getParent } from '../utils/dom/element';
import absoluteList from '../AnimationList/AbsoluteList';
import { isRTL } from '../config';
import { getKey } from '../utils/uid';
var OptionList = (cov_238fl4zerh.s[0]++, absoluteList(function (_ref) {
  var focus = _ref.focus,
      getRef = _ref.getRef,
      other = _objectWithoutProperties(_ref, ["focus", "getRef"]);

  cov_238fl4zerh.f[0]++;
  cov_238fl4zerh.s[1]++;
  return focus ? (cov_238fl4zerh.b[0][0]++,
  /*#__PURE__*/
  React.createElement("div", Object.assign({}, other, {
    ref: getRef,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 18
    }
  }))) : (cov_238fl4zerh.b[0][1]++, null);
}));
cov_238fl4zerh.s[2]++;

var isDescendent = function isDescendent(el, id) {
  cov_238fl4zerh.f[1]++;
  cov_238fl4zerh.s[3]++;

  if (el.getAttribute('data-id') === id) {
    cov_238fl4zerh.b[1][0]++;
    cov_238fl4zerh.s[4]++;
    return true;
  } else {
    cov_238fl4zerh.b[1][1]++;
  }

  cov_238fl4zerh.s[5]++;

  if (!el.parentElement) {
    cov_238fl4zerh.b[2][0]++;
    cov_238fl4zerh.s[6]++;
    return false;
  } else {
    cov_238fl4zerh.b[2][1]++;
  }

  cov_238fl4zerh.s[7]++;
  return isDescendent(el.parentElement, id);
};

var DefaultProps = (cov_238fl4zerh.s[8]++, {
  data: [],
  height: 300,
  clearable: true,
  showArrow: true,
  expandTrigger: 'click',
  childrenKey: 'children'
});

var Cascader =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Cascader, _PureComponent);

  var _super = _createSuper2(Cascader);

  function Cascader(props) {
    var _this2;

    _classCallCheck(this, Cascader);

    cov_238fl4zerh.f[2]++;
    cov_238fl4zerh.s[9]++;
    _this2 = _super.call(this, props);
    _this2.pathChangeTimer = void 0;
    _this2.datum = void 0;
    _this2.selectId = void 0;
    _this2.isRendered = void 0;
    _this2.lastFoucs = void 0;
    _this2.shouldUpdateAfterRef = void 0;
    _this2.ref = void 0;
    _this2.close = void 0;
    _this2.handleBlur = void 0;
    _this2.handleClick = void 0;
    _this2.input = void 0;
    _this2.lastValue = void 0;
    _this2.element = void 0;
    _this2.renderPending = void 0;
    cov_238fl4zerh.s[10]++;
    _this2.state = {
      focus: false,
      path: [],
      position: 'drop-down'
    };
    cov_238fl4zerh.s[11]++;
    _this2.datum = new DatumTree({
      data: props.data,
      loader: props.loader,
      keygen: props.keygen,
      mode: props.mode,
      onChange: props.onChange,
      value: props.value,
      disabled: typeof props.disabled === 'function' ? (cov_238fl4zerh.b[3][0]++, props.disabled) : (cov_238fl4zerh.b[3][1]++, undefined),
      childrenKey: (cov_238fl4zerh.b[4][0]++, props.childrenKey) || (cov_238fl4zerh.b[4][1]++, DefaultProps.childrenKey),
      unmatch: props.unmatch
    });
    cov_238fl4zerh.s[12]++;
    _this2.isRendered = false;
    cov_238fl4zerh.s[13]++;
    _this2.selectId = "select_".concat(getUidStr());
    cov_238fl4zerh.s[14]++;
    _this2.handleClick = _this2.handleState.bind(_assertThisInitialized(_this2), true);
    cov_238fl4zerh.s[15]++;
    _this2.handleBlur = _this2.handleState.bind(_assertThisInitialized(_this2), false);
    cov_238fl4zerh.s[16]++;
    _this2.handleFocus = _this2.handleFocus.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[17]++;
    _this2.handleKeyDown = _this2.handleKeyDown.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[18]++;
    _this2.handleClickAway = _this2.handleClickAway.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[19]++;
    _this2.handlePathChange = _this2.handlePathChange.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[20]++;
    _this2.handleClear = _this2.handleClear.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[21]++;
    _this2.shouldFocus = _this2.shouldFocus.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[22]++;
    _this2.bindRef = _this2.bindRef.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[23]++;
    _this2.handleChange = _this2.handleChange.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[24]++;
    _this2.bindInput = _this2.bindInput.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[25]++;
    _this2.handleRemove = _this2.handleRemove.bind(_assertThisInitialized(_this2));
    cov_238fl4zerh.s[26]++;
    _this2.close = _this2.handleBlur;
    var componentRef = (cov_238fl4zerh.s[27]++, {
      close: _this2.close
    });
    cov_238fl4zerh.s[28]++;

    if (props.getComponentRef) {
      cov_238fl4zerh.b[5][0]++;
      cov_238fl4zerh.s[29]++;

      if (isFunc(props.getComponentRef)) {
        cov_238fl4zerh.b[6][0]++;
        cov_238fl4zerh.s[30]++;
        props.getComponentRef(componentRef);
      } else {
        cov_238fl4zerh.b[6][1]++;
        cov_238fl4zerh.s[31]++;
        props.getComponentRef.current = componentRef;
      }
    } else {
      cov_238fl4zerh.b[5][1]++;
    }

    return _this2;
  }

  _createClass(Cascader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      cov_238fl4zerh.f[3]++;
      cov_238fl4zerh.s[32]++;

      _get(_getPrototypeOf(Cascader.prototype), "componentDidMount", this).call(this);

      cov_238fl4zerh.s[33]++;
      this.setOpenEvent();
      cov_238fl4zerh.s[34]++;
      this.updatePathByValue();
      cov_238fl4zerh.s[35]++;

      if ((cov_238fl4zerh.b[8][0]++, this.props.mode !== undefined) && (cov_238fl4zerh.b[8][1]++, this.props.loader) && (cov_238fl4zerh.b[8][2]++, [0, 1, 2].includes(this.props.mode))) {
        cov_238fl4zerh.b[7][0]++;
        cov_238fl4zerh.s[36]++;
        console.error(new Error("The mode ".concat(this.props.mode, " is not supported when loader setted. Only 3 or 4 can be set.")));
      } else {
        cov_238fl4zerh.b[7][1]++;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      cov_238fl4zerh.f[4]++;
      cov_238fl4zerh.s[37]++;
      this.datum.mode = this.props.mode;
      cov_238fl4zerh.s[38]++;
      this.datum.updateDisabled(this.props.disabled);
      cov_238fl4zerh.s[39]++;
      this.setOpenEvent();

      var _ref2 = (cov_238fl4zerh.s[40]++, this.props),
          onFilter = _ref2.onFilter,
          filterText = _ref2.filterText;

      cov_238fl4zerh.s[41]++;

      if (prevProps.sourceData !== this.props.sourceData) {
        cov_238fl4zerh.b[9][0]++;
        cov_238fl4zerh.s[42]++;
        this.datum.setData(this.props.sourceData, true);
      } else {
        cov_238fl4zerh.b[9][1]++;
      }

      cov_238fl4zerh.s[43]++;

      if (prevProps.value !== this.props.value) {
        cov_238fl4zerh.b[10][0]++;
        cov_238fl4zerh.s[44]++;
        this.datum.setValue((cov_238fl4zerh.b[11][0]++, this.props.value) || (cov_238fl4zerh.b[11][1]++, []));
        cov_238fl4zerh.s[45]++;
        this.updatePathByValue();
      } else {
        cov_238fl4zerh.b[10][1]++;
      }

      cov_238fl4zerh.s[46]++;

      if ((cov_238fl4zerh.b[13][0]++, prevState.focus !== this.state.focus) && (cov_238fl4zerh.b[13][1]++, !this.state.focus) || (cov_238fl4zerh.b[13][2]++, prevProps.open !== this.props.open) && (cov_238fl4zerh.b[13][3]++, !this.props.open)) {
        cov_238fl4zerh.b[12][0]++;
        cov_238fl4zerh.s[47]++;

        if (onFilter) {
          cov_238fl4zerh.b[14][0]++;
          cov_238fl4zerh.s[48]++;
          setTimeout(function () {
            cov_238fl4zerh.f[5]++;
            cov_238fl4zerh.s[49]++;
            onFilter('');
          }, 400);
        } else {
          cov_238fl4zerh.b[14][1]++;
        }

        cov_238fl4zerh.s[50]++;

        if (this.shouldFinal) {
          cov_238fl4zerh.b[15][0]++;
          cov_238fl4zerh.s[51]++;
          this.updatePathByValue(true);
        } else {
          cov_238fl4zerh.b[15][1]++;
        }
      } else {
        cov_238fl4zerh.b[12][1]++;
      }

      cov_238fl4zerh.s[52]++;

      if ((cov_238fl4zerh.b[17][0]++, filterText !== undefined) && (cov_238fl4zerh.b[17][1]++, prevProps.filterText !== filterText)) {
        cov_238fl4zerh.b[16][0]++;
        cov_238fl4zerh.s[53]++;
        this.updatePath();
      } else {
        cov_238fl4zerh.b[16][1]++;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      cov_238fl4zerh.f[6]++;
      cov_238fl4zerh.s[54]++;

      _get(_getPrototypeOf(Cascader.prototype), "componentWillUnmount", this).call(this);

      cov_238fl4zerh.s[55]++;
      this.clearClickAway();
    }
  }, {
    key: "setOpenEvent",
    value: function setOpenEvent() {
      cov_238fl4zerh.f[9]++;
      var focus = (cov_238fl4zerh.s[61]++, (cov_238fl4zerh.b[20][0]++, this.focus) || (cov_238fl4zerh.b[20][1]++, this.props.inputFocus));
      cov_238fl4zerh.s[62]++;

      if (this.lastFoucs !== focus) {
        cov_238fl4zerh.b[21][0]++;
        cov_238fl4zerh.s[63]++;

        if (focus) {
          cov_238fl4zerh.b[22][0]++;
          cov_238fl4zerh.s[64]++;
          this.bindClickAway();
        } else {
          cov_238fl4zerh.b[22][1]++;
          cov_238fl4zerh.s[65]++;

          if (this.lastFoucs !== undefined) {
            cov_238fl4zerh.b[23][0]++;
            cov_238fl4zerh.s[66]++;
            this.clearClickAway();
          } else {
            cov_238fl4zerh.b[23][1]++;
          }
        }
      } else {
        cov_238fl4zerh.b[21][1]++;
      }

      cov_238fl4zerh.s[67]++;
      this.lastFoucs = focus;
    }
  }, {
    key: "bindRef",
    value: function bindRef(el) {
      cov_238fl4zerh.f[10]++;
      cov_238fl4zerh.s[68]++;
      this.ref = el;
    }
  }, {
    key: "bindClickAway",
    value: function bindClickAway() {
      cov_238fl4zerh.f[11]++;
      cov_238fl4zerh.s[69]++;
      document.addEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "bindInput",
    value: function bindInput(input) {
      cov_238fl4zerh.f[12]++;
      cov_238fl4zerh.s[70]++;
      this.input = input;
    }
  }, {
    key: "clearClickAway",
    value: function clearClickAway() {
      cov_238fl4zerh.f[13]++;
      cov_238fl4zerh.s[71]++;
      document.removeEventListener('mousedown', this.handleClickAway);
    }
  }, {
    key: "shouldFocus",
    value: function shouldFocus(el) {
      cov_238fl4zerh.f[14]++;
      cov_238fl4zerh.s[72]++;

      if (el.getAttribute('data-id') === this.selectId) {
        cov_238fl4zerh.b[24][0]++;
        cov_238fl4zerh.s[73]++;
        return true;
      } else {
        cov_238fl4zerh.b[24][1]++;
      }

      cov_238fl4zerh.s[74]++;

      if (getParent(el, ".".concat(cascaderClass('result')))) {
        cov_238fl4zerh.b[25][0]++;
        cov_238fl4zerh.s[75]++;
        return true;
      } else {
        cov_238fl4zerh.b[25][1]++;
      }

      cov_238fl4zerh.s[76]++;
      return false;
    }
  }, {
    key: "updatePath",
    value: function updatePath() {
      cov_238fl4zerh.f[15]++;

      var _ref3 = (cov_238fl4zerh.s[77]++, this.props),
          firstMatchNode = _ref3.firstMatchNode,
          keygen = _ref3.keygen,
          filterText = _ref3.filterText;

      cov_238fl4zerh.s[78]++;

      if ((cov_238fl4zerh.b[27][0]++, !filterText) || (cov_238fl4zerh.b[27][1]++, !firstMatchNode)) {
        cov_238fl4zerh.b[26][0]++;
        cov_238fl4zerh.s[79]++;
        this.setState({
          path: []
        });
        cov_238fl4zerh.s[80]++;
        return;
      } else {
        cov_238fl4zerh.b[26][1]++;
      }

      var key = (cov_238fl4zerh.s[81]++, getKey(firstMatchNode, keygen));
      var current = (cov_238fl4zerh.s[82]++, this.datum.getPath(key));
      cov_238fl4zerh.s[83]++;

      if (!current) {
        cov_238fl4zerh.b[28][0]++;
        cov_238fl4zerh.s[84]++;
        return;
      } else {
        cov_238fl4zerh.b[28][1]++;
      }

      cov_238fl4zerh.s[85]++;
      this.setState(immer(function (draft) {
        cov_238fl4zerh.f[16]++;
        cov_238fl4zerh.s[86]++;
        draft.path = [].concat(_toConsumableArray(current.path), [key]);
      }));
    }
  }, {
    key: "updatePathByValue",
    value: function updatePathByValue(force) {
      cov_238fl4zerh.f[17]++;

      var _ref4 = (cov_238fl4zerh.s[87]++, this.props),
          mode = _ref4.mode,
          value = _ref4.value;

      cov_238fl4zerh.s[88]++;

      if (mode !== undefined) {
        cov_238fl4zerh.b[29][0]++;
        cov_238fl4zerh.s[89]++;
        return;
      } else {
        cov_238fl4zerh.b[29][1]++;
      }

      cov_238fl4zerh.s[90]++;

      if ((cov_238fl4zerh.b[31][0]++, value === this.lastValue) && (cov_238fl4zerh.b[31][1]++, !force)) {
        cov_238fl4zerh.b[30][0]++;
        cov_238fl4zerh.s[91]++;
        return;
      } else {
        cov_238fl4zerh.b[30][1]++;
      }

      cov_238fl4zerh.s[92]++;

      if ((cov_238fl4zerh.b[33][0]++, !value) || (cov_238fl4zerh.b[33][1]++, !value.length)) {
        cov_238fl4zerh.b[32][0]++;
        cov_238fl4zerh.s[93]++;
        this.setState({
          path: []
        });
      } else {
        cov_238fl4zerh.b[32][1]++;
        var v = (cov_238fl4zerh.s[94]++, value[value.length - 1]);
        var data = (cov_238fl4zerh.s[95]++, this.datum.getDataById(v));
        cov_238fl4zerh.s[96]++;

        if ((cov_238fl4zerh.b[35][0]++, data === null) || (cov_238fl4zerh.b[35][1]++, this.datum.isUnMatch(data))) {
          cov_238fl4zerh.b[34][0]++;
          cov_238fl4zerh.s[97]++;
          return;
        } else {
          cov_238fl4zerh.b[34][1]++;
        }

        cov_238fl4zerh.s[98]++;

        try {
          var _ref5 = (cov_238fl4zerh.s[99]++, (cov_238fl4zerh.b[36][0]++, this.datum.getPath(v)) || (cov_238fl4zerh.b[36][1]++, {})),
              _path = _ref5.path;

          cov_238fl4zerh.s[100]++;
          _path = (cov_238fl4zerh.b[37][0]++, _path) || (cov_238fl4zerh.b[37][1]++, []);
          cov_238fl4zerh.s[101]++;
          this.handlePathChange(v, null, _path);
        } catch (e) {
          cov_238fl4zerh.s[102]++;
          console.error(e);
        }
      }
    }
  }, {
    key: "handleClickAway",
    value: function handleClickAway(e) {
      cov_238fl4zerh.f[18]++;
      var desc = (cov_238fl4zerh.s[103]++, isDescendent(e.target, this.selectId));
      cov_238fl4zerh.s[104]++;

      if (!desc) {
        cov_238fl4zerh.b[38][0]++;
        cov_238fl4zerh.s[105]++;

        if (this.props.inputFocus) {
          cov_238fl4zerh.b[39][0]++;
          cov_238fl4zerh.s[106]++;
          this.props.onBlur();
        } else {
          cov_238fl4zerh.b[39][1]++;
        }

        cov_238fl4zerh.s[107]++;
        this.handleState(false);
      } else {
        cov_238fl4zerh.b[38][1]++;
      }
    }
  }, {
    key: "handlePathChange",
    value: function handlePathChange(id, data, path, fromClick) {
      var _this3 = this;

      cov_238fl4zerh.f[19]++;

      var _ref6 = (cov_238fl4zerh.s[108]++, this.props),
          childrenKey = _ref6.childrenKey,
          finalDismiss = _ref6.finalDismiss,
          loader = _ref6.loader;

      cov_238fl4zerh.s[109]++;

      if ((cov_238fl4zerh.b[41][0]++, fromClick) && (cov_238fl4zerh.b[41][1]++, data) && (cov_238fl4zerh.b[41][2]++, childrenKey)) {
        cov_238fl4zerh.b[40][0]++;
        var leaf = (cov_238fl4zerh.s[110]++, (cov_238fl4zerh.b[42][0]++, !data[childrenKey]) || (cov_238fl4zerh.b[42][1]++, data[childrenKey].length === 0));
        cov_238fl4zerh.s[111]++;

        if ((cov_238fl4zerh.b[44][0]++, loader) && (cov_238fl4zerh.b[44][1]++, typeof loader === 'function') && (cov_238fl4zerh.b[44][2]++, data[childrenKey] === undefined)) {
          cov_238fl4zerh.b[43][0]++;
          cov_238fl4zerh.s[112]++;
          leaf = false;
        } else {
          cov_238fl4zerh.b[43][1]++;
        }

        cov_238fl4zerh.s[113]++;

        if ((cov_238fl4zerh.b[46][0]++, finalDismiss) && (cov_238fl4zerh.b[46][1]++, leaf)) {
          cov_238fl4zerh.b[45][0]++;
          cov_238fl4zerh.s[114]++;
          this.handleState(false);
        } else {
          cov_238fl4zerh.b[45][1]++;
        }
      } else {
        cov_238fl4zerh.b[40][1]++;
      }

      cov_238fl4zerh.s[115]++;

      if (this.pathChangeTimer) {
        cov_238fl4zerh.b[47][0]++;
        cov_238fl4zerh.s[116]++;
        clearTimeout(this.pathChangeTimer);
        cov_238fl4zerh.s[117]++;
        this.pathChangeTimer = null;
      } else {
        cov_238fl4zerh.b[47][1]++;
      }

      cov_238fl4zerh.s[118]++;
      this.pathChangeTimer = setTimeout(function () {
        cov_238fl4zerh.f[20]++;
        cov_238fl4zerh.s[119]++;

        _this3.setState({
          path: [].concat(_toConsumableArray(path), [id])
        });
      }, 50);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      cov_238fl4zerh.f[21]++;
      cov_238fl4zerh.s[120]++;

      if (!this.shouldFocus(e.target)) {
        cov_238fl4zerh.b[48][0]++;
        cov_238fl4zerh.s[121]++;
        return;
      } else {
        cov_238fl4zerh.b[48][1]++;
      }

      cov_238fl4zerh.s[122]++;
      this.props.onFocus(e);
    }
  }, {
    key: "handleClear",
    value: function handleClear() {
      var _this4 = this;

      cov_238fl4zerh.f[22]++;

      var _ref7 = (cov_238fl4zerh.s[123]++, this.props),
          mode = _ref7.mode;

      cov_238fl4zerh.s[124]++;
      this.setState({
        path: []
      });
      cov_238fl4zerh.s[125]++;

      if (mode !== undefined) {
        cov_238fl4zerh.b[49][0]++;
        cov_238fl4zerh.s[126]++;
        this.datum.setValue([]);
      } else {
        cov_238fl4zerh.b[49][1]++;
      }

      cov_238fl4zerh.s[127]++;
      this.handleChange([]); // force close

      cov_238fl4zerh.s[128]++;
      setTimeout(function () {
        cov_238fl4zerh.f[23]++;
        cov_238fl4zerh.s[129]++;
        return _this4.handleState(false);
      }, 10);
    }
  }, {
    key: "handleRemove",
    value: function handleRemove(node) {
      cov_238fl4zerh.f[24]++;

      var _ref8 = (cov_238fl4zerh.s[130]++, this.props),
          onChange = _ref8.onChange;

      cov_238fl4zerh.s[131]++;
      this.datum.set(this.datum.getKey(node), 0);
      cov_238fl4zerh.s[132]++;

      if (onChange) {
        cov_238fl4zerh.b[50][0]++;
        cov_238fl4zerh.s[133]++;
        onChange(this.datum.getValue(), node);
      } else {
        cov_238fl4zerh.b[50][1]++;
      }
    }
  }, {
    key: "handleState",
    value: function handleState(focus, e) {
      cov_238fl4zerh.f[25]++;
      cov_238fl4zerh.s[134]++;

      if (this.props.disabled === true) {
        cov_238fl4zerh.b[51][0]++;
        cov_238fl4zerh.s[135]++;
        return;
      } else {
        cov_238fl4zerh.b[51][1]++;
      }

      cov_238fl4zerh.s[136]++;

      if (focus === this.focus) {
        cov_238fl4zerh.b[52][0]++;
        cov_238fl4zerh.s[137]++;
        return;
      } else {
        cov_238fl4zerh.b[52][1]++;
      } // click close icon


      cov_238fl4zerh.s[138]++;

      if ((cov_238fl4zerh.b[54][0]++, focus) && (cov_238fl4zerh.b[54][1]++, e) && (cov_238fl4zerh.b[54][2]++, e.target.classList.contains(cascaderClass('close')))) {
        cov_238fl4zerh.b[53][0]++;
        cov_238fl4zerh.s[139]++;
        return;
      } else {
        cov_238fl4zerh.b[53][1]++;
      } // if remove node, return


      cov_238fl4zerh.s[140]++;

      if ((cov_238fl4zerh.b[56][0]++, e) && (cov_238fl4zerh.b[56][1]++, getParent(e.target, ".".concat(cascaderClass('remove-container'))))) {
        cov_238fl4zerh.b[55][0]++;
        cov_238fl4zerh.s[141]++;
        return;
      } else {
        cov_238fl4zerh.b[55][1]++;
      }

      var _ref9 = (cov_238fl4zerh.s[142]++, this.props),
          _ref9$height = _ref9.height,
          height = _ref9$height === void 0 ? (cov_238fl4zerh.b[57][0]++, DefaultProps.height) : _ref9$height,
          onCollapse = _ref9.onCollapse;

      var _ref10 = (cov_238fl4zerh.s[143]++, this.props),
          position = _ref10.position;

      cov_238fl4zerh.s[144]++;

      if (!position) {
        cov_238fl4zerh.b[58][0]++;
        var windowHeight = (cov_238fl4zerh.s[145]++, docSize.height);
        var bottom = (cov_238fl4zerh.s[146]++, height + this.element.getBoundingClientRect().bottom);
        cov_238fl4zerh.s[147]++;

        if (bottom > windowHeight) {
          cov_238fl4zerh.b[59][0]++;
          cov_238fl4zerh.s[148]++;
          position = 'drop-up';
        } else {
          cov_238fl4zerh.b[59][1]++;
        }
      } else {
        cov_238fl4zerh.b[58][1]++;
      }

      cov_238fl4zerh.s[149]++;

      if (onCollapse) {
        cov_238fl4zerh.b[60][0]++;
        cov_238fl4zerh.s[150]++;
        onCollapse(focus);
      } else {
        cov_238fl4zerh.b[60][1]++;
      }

      cov_238fl4zerh.s[151]++;
      this.setState({
        focus: focus,
        position: (cov_238fl4zerh.b[61][0]++, position) || (cov_238fl4zerh.b[61][1]++, 'drop-down')
      });
      cov_238fl4zerh.s[152]++;

      if (focus) {
        cov_238fl4zerh.b[62][0]++;
        cov_238fl4zerh.s[153]++;
        this.renderPending = false;
      } else {
        cov_238fl4zerh.b[62][1]++;
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      cov_238fl4zerh.f[26]++;
      cov_238fl4zerh.s[154]++;

      if (e.keyCode === 13) {
        cov_238fl4zerh.b[63][0]++;
        cov_238fl4zerh.s[155]++;
        e.preventDefault();
        cov_238fl4zerh.s[156]++;
        this.handleState(!this.focus);
      } else {
        cov_238fl4zerh.b[63][1]++;
      } // fot close the list


      cov_238fl4zerh.s[157]++;

      if (e.keyCode === 9) {
        cov_238fl4zerh.b[64][0]++;
        cov_238fl4zerh.s[158]++;
        this.props.onBlur(); // e.preventDefault()

        cov_238fl4zerh.s[159]++;

        if (this.focus) {
          cov_238fl4zerh.b[65][0]++;
          cov_238fl4zerh.s[160]++;
          this.handleState(false);
        } else {
          cov_238fl4zerh.b[65][1]++;
        }
      } else {
        cov_238fl4zerh.b[64][1]++;
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      cov_238fl4zerh.f[27]++;

      var _ref11 = (cov_238fl4zerh.s[161]++, this.props),
          onChange = _ref11.onChange,
          onFilter = _ref11.onFilter,
          mode = _ref11.mode,
          emptyAfterSelect = _ref11.emptyAfterSelect,
          filterText = _ref11.filterText;

      cov_238fl4zerh.s[162]++;

      if (this.input) {
        cov_238fl4zerh.b[66][0]++;
        cov_238fl4zerh.s[163]++;
        this.input.reset();
        cov_238fl4zerh.s[164]++;
        this.input.focus();
      } else {
        cov_238fl4zerh.b[66][1]++;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _ref12 = (cov_238fl4zerh.s[165]++, args),
          _ref13 = _slicedToArray(_ref12, 1),
          value = _ref13[0];

      cov_238fl4zerh.s[166]++;
      this.lastValue = value;
      cov_238fl4zerh.s[167]++;

      if (onChange) {
        cov_238fl4zerh.b[67][0]++;
        cov_238fl4zerh.s[168]++;
        onChange.apply(void 0, args);
      } else {
        cov_238fl4zerh.b[67][1]++;
      }

      cov_238fl4zerh.s[169]++;

      if ((cov_238fl4zerh.b[69][0]++, onFilter) && (cov_238fl4zerh.b[69][1]++, filterText)) {
        cov_238fl4zerh.b[68][0]++;
        cov_238fl4zerh.s[170]++;

        if (!((cov_238fl4zerh.b[71][0]++, mode !== undefined) && (cov_238fl4zerh.b[71][1]++, !emptyAfterSelect))) {
          cov_238fl4zerh.b[70][0]++;
          cov_238fl4zerh.s[171]++;
          onFilter('');
        } else {
          cov_238fl4zerh.b[70][1]++;
        }
      } else {
        cov_238fl4zerh.b[68][1]++;
      }
    }
  }, {
    key: "renderList",
    value: function renderList() {
      var _this5 = this;

      cov_238fl4zerh.f[28]++;

      var _ref14 = (cov_238fl4zerh.s[172]++, this.props),
          data = _ref14.data,
          keygen = _ref14.keygen,
          renderItem = _ref14.renderItem,
          mode = _ref14.mode,
          loader = _ref14.loader,
          expandTrigger = _ref14.expandTrigger,
          childrenKey = _ref14.childrenKey,
          height = _ref14.height;

      var _ref15 = (cov_238fl4zerh.s[173]++, this.state),
          path = _ref15.path;

      var props = (cov_238fl4zerh.s[174]++, {
        datum: this.datum,
        renderItem: renderItem,
        keygen: keygen,
        loader: loader,
        onPathChange: this.handlePathChange,
        onChange: this.handleChange,
        multiple: mode !== undefined,
        expandTrigger: expandTrigger,
        childrenKey: childrenKey,
        shouldFinal: this.shouldFinal
      });
      var tempData = (cov_238fl4zerh.s[175]++, data);
      var list = (cov_238fl4zerh.s[176]++, [
      /*#__PURE__*/
      React.createElement(CascaderList, Object.assign({}, props, {
        text: undefined,
        key: "root",
        data: tempData,
        id: path[0],
        parentId: "",
        path: [],
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 393,
          columnNumber: 7
        }
      }))]);
      var childs = (cov_238fl4zerh.s[177]++, path.map(function (p, i) {
        cov_238fl4zerh.f[29]++;
        cov_238fl4zerh.s[178]++;
        tempData = (cov_238fl4zerh.b[72][0]++, tempData) && (cov_238fl4zerh.b[72][1]++, tempData instanceof Array) && (cov_238fl4zerh.b[72][2]++, tempData.find(function (d) {
          cov_238fl4zerh.f[30]++;
          var nid = (cov_238fl4zerh.s[179]++, _this5.datum.getKey(d, path[i - 1]));
          cov_238fl4zerh.s[180]++;
          return nid === p;
        }));
        cov_238fl4zerh.s[181]++;

        if ((cov_238fl4zerh.b[74][0]++, tempData) && (cov_238fl4zerh.b[74][1]++, tempData[childrenKey]) && (cov_238fl4zerh.b[74][2]++, tempData[childrenKey].length > 0)) {
          cov_238fl4zerh.b[73][0]++;
          cov_238fl4zerh.s[182]++;
          tempData = tempData[childrenKey];
          cov_238fl4zerh.s[183]++;
          return (
            /*#__PURE__*/
            React.createElement(CascaderList, Object.assign({}, props, {
              key: p,
              text: undefined,
              data: tempData,
              id: path[i + 1],
              parentId: path[i],
              path: path.slice(0, i + 1),
              __self: _this5,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 415,
                columnNumber: 11
              }
            }))
          );
        } else {
          cov_238fl4zerh.b[73][1]++;
        }

        cov_238fl4zerh.s[184]++;
        return null;
      }));
      cov_238fl4zerh.s[185]++;

      if (childs) {
        cov_238fl4zerh.b[75][0]++;
        cov_238fl4zerh.s[186]++;
        list = list.concat(childs);
      } else {
        cov_238fl4zerh.b[75][1]++;
      }

      var listStyle = (cov_238fl4zerh.s[187]++, (cov_238fl4zerh.b[77][0]++, data) && (cov_238fl4zerh.b[77][1]++, data.length === 0) ? (cov_238fl4zerh.b[76][0]++, {
        height: 'auto',
        width: '100%'
      }) : (cov_238fl4zerh.b[76][1]++, {
        height: height
      }));
      cov_238fl4zerh.s[188]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindRef,
          style: listStyle,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 436,
            columnNumber: 7
          }
        }, list)
      );
    }
  }, {
    key: "renderAbsoluteList",
    value: function renderAbsoluteList() {
      cov_238fl4zerh.f[31]++;

      var _ref16 = (cov_238fl4zerh.s[189]++, this.props),
          absolute = _ref16.absolute,
          zIndex = _ref16.zIndex,
          renderOptionList = _ref16.renderOptionList,
          loading = _ref16.loading;

      var _ref17 = (cov_238fl4zerh.s[190]++, this.state),
          position = _ref17.position;

      var _ref18 = (cov_238fl4zerh.s[191]++, this),
          focus = _ref18.focus;

      var className = (cov_238fl4zerh.s[192]++, classnames(selectClass('options'), cascaderClass('options')));
      var rootClass = (cov_238fl4zerh.s[193]++, classnames(cascaderClass((cov_238fl4zerh.b[78][0]++, focus) && (cov_238fl4zerh.b[78][1]++, 'focus'), (cov_238fl4zerh.b[79][0]++, isRTL()) && (cov_238fl4zerh.b[79][1]++, 'rtl')), selectClass(this.state.position)));
      cov_238fl4zerh.s[194]++;

      if ((cov_238fl4zerh.b[81][0]++, !focus) && (cov_238fl4zerh.b[81][1]++, !this.isRendered)) {
        cov_238fl4zerh.b[80][0]++;
        cov_238fl4zerh.s[195]++;
        return null;
      } else {
        cov_238fl4zerh.b[80][1]++;
      }

      cov_238fl4zerh.s[196]++;

      if (!this.element) {
        cov_238fl4zerh.b[82][0]++;
        cov_238fl4zerh.s[197]++;
        this.shouldUpdateAfterRef = true;
        cov_238fl4zerh.s[198]++;
        return null;
      } else {
        cov_238fl4zerh.b[82][1]++;
      }

      cov_238fl4zerh.s[199]++;
      this.isRendered = true;
      var list = (cov_238fl4zerh.s[200]++, this.renderList());
      cov_238fl4zerh.s[201]++;
      return (
        /*#__PURE__*/
        React.createElement(OptionList, {
          autoAdapt: true,
          rootClass: rootClass,
          className: className,
          position: position,
          absolute: absolute,
          focus: focus,
          parentElement: this.element,
          "data-id": this.selectId,
          zIndex: zIndex,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 456,
            columnNumber: 7
          }
        }, renderOptionList ? (cov_238fl4zerh.b[83][0]++, renderOptionList(list, {
          loading: !!loading
        })) : (cov_238fl4zerh.b[83][1]++, list))
      );
    }
  }, {
    key: "renderFilterList",
    value: function renderFilterList() {
      cov_238fl4zerh.f[32]++;

      var _ref19 = (cov_238fl4zerh.s[202]++, this.props),
          absolute = _ref19.absolute,
          onFilter = _ref19.onFilter,
          wideMatch = _ref19.wideMatch,
          filterText = _ref19.filterText,
          zIndex = _ref19.zIndex,
          data = _ref19.data,
          childrenKey = _ref19.childrenKey,
          renderItem = _ref19.renderItem,
          expandTrigger = _ref19.expandTrigger,
          filterDataChange = _ref19.filterDataChange,
          height = _ref19.height,
          loading = _ref19.loading,
          renderOptionList = _ref19.renderOptionList;

      var _ref20 = (cov_238fl4zerh.s[203]++, this.state),
          position = _ref20.position;

      var _ref21 = (cov_238fl4zerh.s[204]++, this),
          focus = _ref21.focus;

      var className = (cov_238fl4zerh.s[205]++, classnames(cascaderClass((cov_238fl4zerh.b[84][0]++, focus) && (cov_238fl4zerh.b[84][1]++, 'focus'), (cov_238fl4zerh.b[85][0]++, isRTL()) && (cov_238fl4zerh.b[85][1]++, 'rtl')), selectClass(this.state.position)));
      cov_238fl4zerh.s[206]++;
      return (
        /*#__PURE__*/
        React.createElement(FilterList, {
          shouldFinal: this.shouldFinal,
          fixed: "min",
          rootClass: className,
          position: position,
          absolute: absolute,
          focus: focus,
          parentElement: this.element,
          "data-id": this.selectId,
          zIndex: zIndex,
          data: data,
          childrenKey: childrenKey,
          renderItem: renderItem,
          expandTrigger: expandTrigger,
          filterDataChange: filterDataChange,
          datum: this.datum,
          onChange: this.handleChange,
          onPathChange: this.handlePathChange,
          wideMatch: wideMatch,
          onFilter: onFilter,
          filterText: filterText,
          height: height,
          loading: loading,
          renderOptionList: renderOptionList,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 493,
            columnNumber: 7
          }
        })
      );
    }
  }, {
    key: "renderPanel",
    value: function renderPanel() {
      cov_238fl4zerh.f[33]++;

      var _ref22 = (cov_238fl4zerh.s[207]++, this.props),
          filterText = _ref22.filterText,
          data = _ref22.data,
          mode = _ref22.mode,
          loading = _ref22.loading;

      cov_238fl4zerh.s[208]++;

      if (loading) {
        cov_238fl4zerh.b[86][0]++;
        cov_238fl4zerh.s[209]++;
        return this.renderFilterList();
      } else {
        cov_238fl4zerh.b[86][1]++;
      }

      cov_238fl4zerh.s[210]++;

      if ((cov_238fl4zerh.b[88][0]++, !filterText) || (cov_238fl4zerh.b[88][1]++, filterText) && (cov_238fl4zerh.b[88][2]++, mode !== undefined) || (cov_238fl4zerh.b[88][3]++, data) && (cov_238fl4zerh.b[88][4]++, data.length === 0)) {
        cov_238fl4zerh.b[87][0]++;
        cov_238fl4zerh.s[211]++;
        return this.renderAbsoluteList();
      } else {
        cov_238fl4zerh.b[87][1]++;
      }

      cov_238fl4zerh.s[212]++;
      return this.renderFilterList();
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      cov_238fl4zerh.f[34]++;

      var _ref23 = (cov_238fl4zerh.s[213]++, this.props),
          placeholder = _ref23.placeholder,
          disabled = _ref23.disabled,
          size = _ref23.size,
          other = _objectWithoutProperties(_ref23, ["placeholder", "disabled", "size"]);

      var _ref24 = (cov_238fl4zerh.s[214]++, this),
          focus = _ref24.focus;

      var className = (cov_238fl4zerh.s[215]++, classnames(cascaderClass('_', size, (cov_238fl4zerh.b[89][0]++, focus) && (cov_238fl4zerh.b[89][1]++, 'focus'), (cov_238fl4zerh.b[90][0]++, other.mode !== undefined) && (cov_238fl4zerh.b[90][1]++, 'multiple'), (cov_238fl4zerh.b[91][0]++, disabled === true) && (cov_238fl4zerh.b[91][1]++, 'disabled'), (cov_238fl4zerh.b[92][0]++, isRTL()) && (cov_238fl4zerh.b[92][1]++, 'rtl')), selectClass(this.state.position, (cov_238fl4zerh.b[93][0]++, focus) && (cov_238fl4zerh.b[93][1]++, 'focus'))));
      cov_238fl4zerh.s[216]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          // eslint-disable-next-line
          tabIndex: disabled === true ? (cov_238fl4zerh.b[94][0]++, -1) : (cov_238fl4zerh.b[94][1]++, 0),
          className: className,
          onFocus: this.handleFocus,
          onClick: this.handleClick,
          "data-id": this.selectId,
          onKeyDown: this.handleKeyDown,
          ref: function ref(el) {
            cov_238fl4zerh.f[35]++;
            cov_238fl4zerh.s[217]++;
            _this6.element = el;
            cov_238fl4zerh.s[218]++;

            if ((cov_238fl4zerh.b[96][0]++, el) && (cov_238fl4zerh.b[96][1]++, _this6.shouldUpdateAfterRef)) {
              cov_238fl4zerh.b[95][0]++;
              cov_238fl4zerh.s[219]++;
              _this6.shouldUpdateAfterRef = false;
              cov_238fl4zerh.s[220]++;

              _this6.forceUpdate();
            } else {
              cov_238fl4zerh.b[95][1]++;
            }
          },
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 545,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Result, Object.assign({}, other, {
          focus: focus,
          multiple: other.mode !== undefined,
          datum: this.datum,
          placeholder: placeholder,
          onClear: this.handleClear,
          onPathChange: this.handlePathChange,
          bindInput: this.bindInput,
          handleRemove: this.handleRemove,
          selectId: this.selectId,
          showList: this.handleClick,
          size: size,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 561,
            columnNumber: 9
          }
        })), this.renderPanel())
      );
    }
  }, {
    key: "focus",
    get: function get() {
      cov_238fl4zerh.f[7]++;
      cov_238fl4zerh.s[56]++;

      if ('open' in this.props) {
        cov_238fl4zerh.b[18][0]++;
        cov_238fl4zerh.s[57]++;
        return !!this.props.open;
      } else {
        cov_238fl4zerh.b[18][1]++;
      }

      cov_238fl4zerh.s[58]++;
      return this.state.focus;
    }
  }, {
    key: "shouldFinal",
    get: function get() {
      cov_238fl4zerh.f[8]++;

      var _ref25 = (cov_238fl4zerh.s[59]++, this.props),
          expandTrigger = _ref25.expandTrigger,
          _final = _ref25["final"];

      cov_238fl4zerh.s[60]++;
      return (cov_238fl4zerh.b[19][0]++, expandTrigger === 'hover-only') || (cov_238fl4zerh.b[19][1]++, !!_final);
    }
  }]);

  return Cascader;
}(PureComponent);

Cascader.defaultProps = DefaultProps;
cov_238fl4zerh.s[221]++;
Cascader.defaultProps = {
  clearable: true,
  expandTrigger: 'click',
  height: 300,
  data: [],
  childrenKey: 'children',
  showArrow: true
};
export default Cascader;